// German translations for React Admin
// Based on ra-language-german but inline to avoid dependency issues

const germanMessages = {
    ra: {
        action: {
            add_filter: 'Filter hinzufügen',
            add: 'Hinzufügen',
            back: 'Zurück',
            bulk_actions: '%{smart_count} ausgewählt',
            cancel: 'Abbrechen',
            clear_array_input: 'Liste löschen',
            clear_input_value: 'Wert löschen',
            clone: 'Duplizieren',
            confirm: 'Bestätigen',
            create: 'Anlegen',
            create_item: '%{item} anlegen',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            export: 'Exportieren',
            list: 'Liste',
            refresh: 'Aktualisieren',
            remove_filter: 'Filter entfernen',
            remove_all_filters: 'Alle Filter entfernen',
            remove: 'Entfernen',
            save: 'Speichern',
            search: 'Suchen',
            select_all: 'Alle auswählen',
            select_row: 'Zeile auswählen',
            show: 'Anzeigen',
            sort: 'Sortieren',
            undo: 'Rückgängig',
            unselect: 'Abwählen',
            expand: 'Erweitern',
            close: 'Schließen',
            open_menu: 'Menü öffnen',
            close_menu: 'Menü schließen',
            update: 'Aktualisieren',
            move_up: 'Nach oben',
            move_down: 'Nach unten',
            open: 'Öffnen',
            toggle_theme: 'Theme umschalten',
            select_columns: 'Spalten',
            reset: 'Zurücksetzen',
            search_columns: 'Spalten durchsuchen',
            select_all_button: 'Alle auswählen',
            update_application: 'Anwendung neu laden',
        },
        boolean: {
            true: 'Ja',
            false: 'Nein',
            null: ' ',
        },
        page: {
            create: '%{name} anlegen',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Ein Fehler ist aufgetreten',
            list: '%{name}',
            loading: 'Lade',
            not_found: 'Nicht gefunden',
            show: '%{name} #%{id}',
            empty: 'Noch keine %{name}.',
            invite: 'Möchten Sie eine anlegen?',
        },
        input: {
            file: {
                upload_several:
                    'Dateien zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Datei zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            image: {
                upload_several:
                    'Bilder zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Bild zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            references: {
                all_missing: 'Die verknüpften Daten konnten nicht gefunden werden.',
                many_missing:
                    'Mindestens eine der verknüpften Daten ist nicht mehr verfügbar.',
                single_missing:
                    'Die verknüpften Daten sind nicht mehr verfügbar.',
            },
            password: {
                toggle_visible: 'Passwort verbergen',
                toggle_hidden: 'Passwort anzeigen',
            },
        },
        message: {
            about: 'Über',
            are_you_sure: 'Sind Sie sicher?',
            bulk_delete_content:
                'Sind Sie sicher, dass Sie %{name} löschen möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente löschen möchten?',
            bulk_delete_title:
                '%{name} löschen |||| %{smart_count} %{name} löschen',
            bulk_update_content:
                'Sind Sie sicher, dass Sie %{name} aktualisieren möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente aktualisieren möchten?',
            bulk_update_title:
                '%{name} aktualisieren |||| %{smart_count} %{name} aktualisieren',
            delete_content: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
            delete_title: '%{name} #%{id} löschen',
            details: 'Details',
            error:
                'Ein Fehler ist aufgetreten und Ihre Anfrage konnte nicht abgeschlossen werden.',
            invalid_form: 'Das Formular ist nicht korrekt. Bitte überprüfen Sie die Fehler',
            loading: 'Die Seite lädt, einen Moment bitte',
            no: 'Nein',
            not_found:
                'Sie haben eine falsche URL eingegeben oder einen fehlerhaften Link angeklickt.',
            yes: 'Ja',
            unsaved_changes:
                'Einige Ihrer Änderungen wurden nicht gespeichert. Sind Sie sicher, dass Sie diese ignorieren möchten?',
        },
        navigation: {
            no_results: 'Keine Ergebnisse gefunden',
            no_more_results:
                'Seite %{page} liegt außerhalb des Seitenbereichs. Versuchen Sie die vorherige Seite.',
            page_out_of_boundaries: 'Seite %{page} liegt außerhalb der Grenzen',
            page_out_from_end: 'Kann nicht über die letzte Seite hinausgehen',
            page_out_from_begin: 'Kann nicht vor Seite 1 gehen',
            page_range_info: '%{offsetBegin}-%{offsetEnd} von %{total}',
            partial_page_range_info:
                '%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}',
            current_page: 'Seite %{page}',
            page: 'Gehe zu Seite %{page}',
            first: 'Gehe zur ersten Seite',
            last: 'Gehe zur letzten Seite',
            next: 'Weiter',
            previous: 'Zurück',
            page_rows_per_page: 'Zeilen pro Seite:',
            skip_nav: 'Zum Inhalt springen',
        },
        sort: {
            sort_by: 'Sortieren nach %{field} %{order}',
            ASC: 'aufsteigend',
            DESC: 'absteigend',
        },
        auth: {
            auth_check_error: 'Bitte melden Sie sich an, um fortzufahren',
            user_menu: 'Profil',
            username: 'Benutzername',
            password: 'Passwort',
            sign_in: 'Anmelden',
            sign_in_error: 'Authentifizierung fehlgeschlagen, bitte erneut versuchen',
            logout: 'Abmelden',
        },
        notification: {
            updated:
                'Element erfolgreich aktualisiert |||| %{smart_count} Elemente erfolgreich aktualisiert',
            created: 'Element erfolgreich angelegt',
            deleted:
                'Element erfolgreich gelöscht |||| %{smart_count} Elemente erfolgreich gelöscht',
            bad_item: 'Fehlerhaftes Element',
            item_doesnt_exist: 'Element existiert nicht',
            http_error: 'Serverfehler',
            data_provider_error:
                'dataProvider Fehler. Prüfen Sie die Konsole für Details.',
            i18n_error:
                'Die Übersetzungen für die angegebene Sprache konnten nicht geladen werden',
            canceled: 'Aktion abgebrochen',
            logged_out: 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.',
        },
        validation: {
            required: 'Erforderlich',
            minLength: 'Mindestens %{min} Zeichen',
            maxLength: 'Maximal %{max} Zeichen',
            minValue: 'Mindestens %{min}',
            maxValue: 'Maximal %{max}',
            number: 'Muss eine Zahl sein',
            email: 'Muss eine gültige E-Mail-Adresse sein',
            oneOf: 'Muss einer der folgenden Werte sein: %{options}',
            regex: 'Muss dem Format entsprechen (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Gespeicherte Abfragen',
            query_name: 'Abfragename',
            new_label: 'Aktuelle Abfrage speichern...',
            new_dialog_title: 'Aktuelle Abfrage speichern als',
            remove_label: 'Gespeicherte Abfrage entfernen',
            remove_label_with_name: 'Abfrage "%{name}" entfernen',
            remove_dialog_title: 'Gespeicherte Abfrage entfernen?',
            remove_message: 'Sind Sie sicher, dass Sie diesen Eintrag aus Ihrer Liste der gespeicherten Abfragen entfernen möchten?',
            help: 'Filter die Liste und speichere diese Abfrage für später',
        },
        configurable: {
            customize: 'Anpassen',
            configureMode: 'Diese Seite konfigurieren',
            inspector: {
                title: 'Inspektor',
                content: 'Bewegen Sie den Mauszeiger über UI-Elemente, um sie zu konfigurieren',
                reset: 'Einstellungen zurücksetzen',
                hideAll: 'Alle ausblenden',
                showAll: 'Alle anzeigen',
            },
            Datagrid: {
                title: 'Datentabelle',
                unlabeled: 'Unbenannte Spalte #%{column}',
            },
            SimpleForm: {
                title: 'Formular',
                unlabeled: 'Unbenanntes Eingabefeld #%{input}',
            },
            SimpleList: {
                title: 'Liste',
                primaryText: 'Primärer Text',
                secondaryText: 'Sekundärer Text',
                tertiaryText: 'Tertiärer Text',
            },
        },
    },
};

export const de = {
    ...germanMessages,
    resources: {
        companies: {
            name: 'Firma |||| Firmen',
            fields: {
                name: 'Name',
                email: 'E-Mail',
                phone: 'Telefon',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                billingStreet: 'Rechnungsstraße',
                billingZip: 'Rechnungs-PLZ',
                billingCity: 'Rechnungsstadt',
                billingCountry: 'Rechnungsland',
                taxId: 'Steuernummer / USt-ID',
                commercialRegister: 'Handelsregisternummer',
                website: 'Webseite',
                active: 'Aktiv',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                address: 'Adresse',
                billing: 'Rechnungsadresse',
                legal: 'Rechtliche Informationen',
            },
        },
        users: {
            name: 'Benutzer |||| Benutzer',
            fields: {
                email: 'E-Mail',
                firstName: 'Vorname',
                lastName: 'Nachname',
                phone: 'Telefon',
                mobile: 'Mobil',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                dateOfBirth: 'Geburtsdatum',
                jobTitle: 'Position',
                department: 'Abteilung',
                language: 'Bevorzugte Sprache',
                company: 'Firma',
                roles: 'Rollen',
                userRoles: 'Rollen',
                password: 'Passwort',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                contact: 'Kontakt & Adresse',
                work: 'Arbeitsinformationen',
                personal: 'Persönlich',
                roles: 'Rollen & Berechtigungen',
            },
        },
        profile: {
            name: 'Profil',
            fields: {
                id: 'ID',
                email: 'E-Mail',
                firstName: 'Vorname',
                lastName: 'Nachname',
                phone: 'Telefon',
                mobile: 'Mobil',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                dateOfBirth: 'Geburtsdatum',
                jobTitle: 'Position',
                department: 'Abteilung',
                language: 'Bevorzugte Sprache',
            },
        },
        invitations: {
            name: 'Einladung |||| Einladungen',
            fields: {
                email: 'E-Mail',
                company: 'Firma',
                roles: 'Rollen',
                token: 'Token',
                createdAt: 'Erstellt am',
                expiresAt: 'Gültig bis',
                used: 'Verwendet',
                usedAt: 'Verwendet am',
                invitedBy: 'Eingeladen von',
                registeredUser: 'Registrierter Benutzer',
            },
        },
        roles: {
            name: 'Rolle |||| Rollen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                permissions: 'Berechtigungen',
            },
        },
        permissions: {
            name: 'Berechtigung |||| Berechtigungen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
            },
        },
        products: {
            name: 'Produkt |||| Produkte',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                price: 'Preis',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
        },
        licenses: {
            name: 'Lizenz |||| Lizenzen',
            fields: {
                company: 'Firma',
                product: 'Produkt',
                validFrom: 'Gültig ab',
                validUntil: 'Gültig bis',
                maxUsers: 'Max. Benutzer',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
        },
    },
    custom: {
        changePassword: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        passwordChanged: 'Passwort erfolgreich geändert',
        language: 'Sprache',
        profile: {
            menuItem: 'Mein Profil',
            emailLocked: 'E-Mail-Adressen können nur von Superadmins geändert werden. Bitte wende dich an den Support.',
            title: 'Mein Profil',
            notLoggedIn: 'Sie sind nicht angemeldet',
        },
    },
    profile: {
        avatar: {
            title: 'Profilbild',
            hint: 'JPG, PNG, GIF oder WebP. Max. 2 MB.',
            remove: 'Bild entfernen',
            uploadSuccess: 'Profilbild erfolgreich hochgeladen',
            uploadError: 'Fehler beim Hochladen des Profilbilds',
            deleteSuccess: 'Profilbild entfernt',
            deleteError: 'Fehler beim Entfernen des Profilbilds',
            invalidType: 'Ungültiges Dateiformat. Erlaubt: JPG, PNG, GIF, WebP',
            tooLarge: 'Datei zu groß. Maximal 2 MB.',
        },
    },
    courseEnrollmentDialog: {
        title: 'Teilnehmer',
        addUser: 'Benutzer einschreiben',
        bulkEnroll: 'Massen-Einschreibung',
        selectUser: 'Benutzer auswählen',
        enroll: 'Einschreiben',
        remove: 'Abmelden',
        enrollSuccess: 'Benutzer erfolgreich eingeschrieben',
        enrollError: 'Fehler beim Einschreiben',
        alreadyEnrolled: 'Dieser Benutzer ist bereits eingeschrieben',
        removeSuccess: 'Teilnehmer erfolgreich abgemeldet',
        removeError: 'Fehler beim Abmelden',
        confirmRemove: 'Möchten Sie diesen Teilnehmer wirklich abmelden?',
        loadError: 'Fehler beim Laden der Teilnehmer',
        noEnrollments: 'Noch keine Teilnehmer eingeschrieben',
        table: {
            name: 'Name',
            email: 'E-Mail',
            status: 'Status',
            progress: 'Fortschritt',
            enrolledAt: 'Eingeschrieben am',
        },
        status: {
            enrolled: 'Eingeschrieben',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            failed: 'Nicht bestanden',
            pending_approval: 'Ausstehend',
            rejected: 'Abgelehnt',
        },
    },
    enrollments: {
        manage: {
            title: 'Einschreibungen verwalten',
            importCsv: 'Import CSV',
            exportCsv: 'Export CSV',
            enrollUser: 'Benutzer einschreiben',
            bulkEnroll: 'Massen-Einschreibung',
            bulkPartial: '%{enrolled} eingeschrieben, %{skipped} übersprungen, %{failed} nicht eingeschrieben: %{reason}',
            bulkCourse: 'Kurs',
            deleteConfirm: 'Einschreibung von %{user} in „%{course}“ löschen? Der Lernfortschritt in diesem Kurs geht dabei verloren. Das lässt sich nicht rückgängig machen.',
            selectCourse: 'Kurs auswählen',
            allCourses: 'Alle Kurse',
            statusFilter: 'Status Filter',
            statusAll: 'Alle',
            statusEnrolled: 'Eingeschrieben',
            statusInProgress: 'In Bearbeitung',
            statusCompleted: 'Abgeschlossen',
            statusFailed: 'Nicht bestanden',
            loading: 'Lade Einschreibungen...',
            noEnrollments: 'Keine Einschreibungen für diesen Kurs gefunden.',
            table: {
                name: 'Name',
                email: 'Email',
                course: 'Kurs',
                status: 'Status',
                progress: 'Fortschritt',
                score: 'Punktzahl',
                enrolled: 'Eingeschrieben',
                started: 'Gestartet',
                completed: 'Abgeschlossen',
                time: 'Zeit',
                actions: 'Aktionen',
            },
            dialog: {
                title: 'Benutzer einschreiben',
                user: 'Benutzer',
                userHelp: 'Wählen Sie einen Benutzer aus dem SSO-System',
                course: 'Kurs',
                enroll: 'Einschreiben',
            },
        },
        dashboard: {
            title: 'Enrollment Dashboard',
            enrollUser: 'Benutzer einschreiben',
            stats: {
                total: 'Gesamt Einschreibungen',
                active: 'Aktive Lernende',
                completed: 'Abgeschlossen',
                avgProgress: 'Ø Fortschritt',
            },
            courseStats: {
                title: 'Kurs-Statistiken',
                noData: 'Keine Kursdaten verfügbar.',
                table: {
                    course: 'Kurs',
                    enrollments: 'Einschreibungen',
                    completionRate: 'Abschlussquote',
                    avgProgress: 'Ø Fortschritt',
                    avgScore: 'Ø Punktzahl',
                },
            },
        },
        csvImport: {
            title: 'CSV Import - Benutzer einschreiben',
            formatInfo: 'CSV-Format: Eine E-Mail-Adresse pro Zeile. Erste Zeile wird als Header übersprungen.',
            course: 'Kurs',
            selectFile: 'CSV-Datei auswählen',
            file: 'Datei',
            import: 'Importieren',
            selectFileAndCourse: 'Bitte wählen Sie eine CSV-Datei und einen Kurs aus',
            userNotFound: 'Benutzer nicht gefunden',
            enrollError: 'Fehler beim Einschreiben',
            importComplete: 'Import abgeschlossen: %{success} erfolgreich, %{failed} fehlgeschlagen',
            processingError: 'Fehler beim Verarbeiten der CSV-Datei',
            results: {
                success: 'Erfolgreich',
                failed: 'Fehlgeschlagen',
                errors: 'Fehler',
            },
        },
    },
    menu: {
        dashboard: 'Dashboard',
        mediaLibrary: 'Medienbibliothek',
        wiki: 'Aktuelles & Wissen',
        courses: 'Kurse',
        courseCatalogs: 'Kursverwaltung',
        aiGenerator: 'KI-Generator',
        knowledgeBase: 'Wissensbasis',
        courseCatalog: 'Kurskatalog',
        learningPaths: 'Lernpfade',
        achievements: 'Meine Erfolge',
        enrollmentDashboard: 'Enrollment Dashboard',
        manageEnrollments: 'Einschreibungen verwalten',
        enrollments: 'Einschreibungen',
        myCourses: 'Meine Kurse',
        myCertificates: 'Meine Zertifikate',
        bookmarks: 'Meine Lesezeichen',
        analytics: 'Statistiken',
        instructorAnalytics: 'Trainer-Dashboard',
        learningGroups: 'Lerngruppen',
        peerReview: 'Peer-Reviews',
        library: 'Bibliothek',
        notes: 'Meine Notizen',
        certificates: 'Zertifikate',
    },
    dashboard: {
        title: 'Dashboard',
        defaultName: 'Lernende/r',
        welcome: 'Willkommen zurück, %{firstName}!',
        subtitle: 'Ihr Lern- und Wissensportal',
        quickAccess: 'Schnellzugriff',
        pendingReviews: 'Ausstehende Reviews',
        myLearningGroups: 'Meine Lerngruppen',
        stats: {
            myCourses: 'Meine Kurse',
            inProgress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            wikiArticles: 'Aktuelles & Wissen',
            media: 'Medien',
        },
        quickAccessCards: {
            myCourses: {
                title: 'Meine Kurse',
                description: 'Setzen Sie Ihr Lernen fort',
            },
            catalogs: {
                title: 'Kursverwaltung',
                description: 'Kataloge + Kurse anlegen / bearbeiten',
            },
            catalog: {
                title: 'Kurskatalog',
                description: 'Neue Kurse entdecken + buchen',
            },
            wiki: {
                title: 'Aktuelles & Wissen',
                description: 'Artikel und Neuigkeiten durchsuchen',
            },
            media: {
                title: 'Medienbibliothek',
                description: 'Dateien verwalten',
            },
        },
        activities: {
            mostViewed: '📈 Meist gelesene Artikel',
            recentArticles: '🆕 Neueste Artikel',
            recentFiles: '📁 Neueste Dateien',
            noArticles: 'Keine Artikel verfügbar',
            noNewArticles: 'Keine neuen Artikel',
            noFiles: 'Keine Dateien vorhanden',
            views: 'Aufrufe',
            published: 'Veröffentlicht',
            draft: 'Entwurf',
        },
    },
    myCourses: {
        title: 'Meine Kurse',
        loading: 'Lade Kurse...',
        courseNotFound: 'Kurs nicht gefunden',
        enrolled: 'Eingeschrieben',
        learningTime: 'Lernzeit',
        completed: 'Abgeschlossen',
        noEnrollments: 'Sie sind derzeit in keinem Kurs eingeschrieben. Wenden Sie sich an Ihren Administrator, um sich in Kurse einzuschreiben.',
        noCoursesInProgress: 'Keine Kurse in Bearbeitung.',
        allCoursesStarted: 'Alle Kurse wurden bereits gestartet.',
        noCoursesCompleted: 'Noch keine Kurse abgeschlossen.',
        status: {
            completed: 'Abgeschlossen',
            inProgress: 'In Bearbeitung',
            failed: 'Nicht bestanden',
            notStarted: 'Noch nicht begonnen',
            pendingApproval: 'Ausstehend',
            rejected: 'Abgelehnt',
            suspended: 'Pausiert',
        },
        buttons: {
            start: 'Kurs starten',
            continue: 'Fortsetzen',
            review: 'Erneut ansehen',
            retry: 'Erneut versuchen',
        },
        tabs: {
            all: 'Alle (%{count})',
            inProgress: 'In Bearbeitung (%{count})',
            notStarted: 'Noch nicht begonnen (%{count})',
            completed: 'Abgeschlossen (%{count})',
        },
    },
    certificates: {
        title: 'Meine Zertifikate',
        loading: 'Lade Zertifikate...',
        noCertificates: 'Keine Zertifikate vorhanden.',
        search: 'Zertifikate suchen...',
        download: 'Herunterladen',
        shareTooltip: 'Verifizierungslink kopieren',
        linkCopied: 'Link in die Zwischenablage kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        issuedAt: 'Ausgestellt am',
        expiresAt: 'Gültig bis',
        score: 'Punktzahl',
        verificationCode: 'Verifizierungscode',
        status: {
            valid: 'Gültig',
            expired: 'Abgelaufen',
            expiringSoon: 'Läuft in %{days} Tagen ab',
        },
        tabs: {
            all: 'Alle (%{count})',
            valid: 'Gültig (%{count})',
            expired: 'Abgelaufen (%{count})',
        },
    },
    layout: {
        language: 'Sprache',
        profile: 'Profil',
        changePassword: 'Passwort ändern',
        help: 'Hilfe',
        logout: 'Ausloggen',
        loadingTranslations: 'Übersetzungen werden geladen...',
    },
    bottomNav: {
        catalogs: 'Kataloge',
        media: 'Medien',
        learningPaths: 'Lernpfade',
        achievements: 'Erfolge',
    },
    wiki: {
        title: 'Aktuelles & Wissen',
        newArticle: 'Neuer Artikel',
        searchPlaceholder: 'Artikel suchen (Titel und Zusammenfassung)...',
        categoriesButton: 'Kategorien',
        categoryLabel: 'Kategorie',
        allCategories: 'Alle Kategorien',
        noArticles: 'Keine Artikel gefunden',
        loading: 'Laden...',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        view: 'Ansehen',
        confirmDelete: 'Möchten Sie den Artikel "%{title}" wirklich löschen?',
        deleted: 'Artikel gelöscht',
        deleteError: 'Fehler beim Löschen',
        loadError: 'Fehler beim Laden der Artikel',
        company: 'Firma',
        platform: 'FAQ',
        updated: 'Aktualisiert',
        editor: {
            newArticle: 'Neuer Artikel',
            editArticle: 'Artikel bearbeiten',
            back: 'Zurück',
            save: 'Speichern',
            saving: 'Speichern...',
            saveAndPublish: 'Speichern & Veröffentlichen',
            title: 'Titel',
            slug: 'URL-Slug',
            slugHelp: 'URL-freundlicher Name (wird automatisch generiert)',
            summary: 'Zusammenfassung',
            summaryHelp: 'Kurze Beschreibung für die Artikelübersicht',
            status: 'Status',
            category: 'Kategorie',
            none: 'Keine',
            visibility: 'Sichtbarkeit',
            visibilityCompany: 'Firma (nur für Firmen-Benutzer sichtbar)',
            visibilityGlobal: 'Global (für alle Unternehmen sichtbar)',
            content: 'Inhalt',
            version: 'Version',
            versionHistory: 'Versionsverlauf',
        },
        status: {
            draft: 'Entwurf',
            published: 'Veröffentlicht',
            archived: 'Archiviert',
        },
        tabs: {
            all: 'Alle',
            drafts: 'Entwürfe',
            published: 'Veröffentlicht',
            archived: 'Archiviert',
        },
        favorites: 'Favoriten',
        noFavorites: 'Keine Favoriten vorhanden',
        noFavoritesHint: 'Markieren Sie Artikel als Favoriten, um sie hier schnell wiederzufinden.',
        categories: {
            title: 'Wiki-Kategorien',
            back: 'Zurück',
            newCategory: 'Neue Kategorie',
            editCategory: 'Kategorie bearbeiten',
            noCategories: 'Keine Kategorien vorhanden',
            loadError: 'Fehler beim Laden der Kategorien',
            saveError: 'Fehler beim Speichern',
            deleteError: 'Fehler beim Löschen',
            updateSuccess: 'Kategorie aktualisiert',
            createSuccess: 'Kategorie erstellt',
            deleteSuccess: 'Kategorie gelöscht',
            nameRequired: 'Bitte geben Sie einen Namen ein',
            confirmDelete: 'Möchten Sie die Kategorie "%{name}" wirklich löschen?',
            companyCategory: 'Firmen-Kategorie',
            globalCategory: 'Globale Kategorie',
            table: {
                name: 'Name',
                color: 'Farbe',
                icon: 'Icon',
                description: 'Beschreibung',
                type: 'Typ',
                actions: 'Aktionen',
            },
            form: {
                name: 'Name',
                color: 'Farbe',
                icon: 'Icon (Optional)',
                noIcon: 'Kein Icon',
                description: 'Beschreibung',
                globalCategory: 'Globale Kategorie (für alle Unternehmen sichtbar)',
            },
            isPublic: 'Öffentlich (FAQ)',
            isPublicHelp: 'Öffentliche Kategorien sind ohne Login unter /faq erreichbar',
        },
    },
    courses: {
        title: 'Kurse',
        catalog: 'Katalog',
        backToCatalogs: 'Zurück zu Katalogen',
        coursesIn: 'Kurse in: %{name}',
        newCourse: 'Neuer Kurs',
        editCourse: 'Kurs bearbeiten',
        createFirst: 'Ersten Kurs erstellen',
        manageLessons: 'Lektionen verwalten',
        fromLibrary: 'Aus Bibliothek',
        noCourses: 'Noch keine Kurse vorhanden',
        loading: 'Lade Kurse...',
        loadError: 'Fehler beim Laden des Katalogs',
        loadCoursesError: 'Fehler beim Laden der Kurse',
        saveError: 'Fehler beim Speichern des Kurses',
        deleteError: 'Fehler beim Archivieren des Kurses',
        updateSuccess: 'Kurs erfolgreich aktualisiert',
        createSuccess: 'Kurs erfolgreich erstellt',
        deleteSuccess: 'Kurs erfolgreich archiviert',
        confirmDelete: 'Möchten Sie diesen Kurs wirklich archivieren?\n\nDer Kurs wird für alle Teilnehmer unsichtbar und nicht mehr zugänglich. Bereits abgeschlossene Zertifikate bleiben erhalten. Statistiken werden nicht verändert.',
        sequential: 'Sequenziell',
        duration: '%{minutes} Min.',
        lessonsCount: '%{count} Lektionen',
        difficulty: {
            beginner: 'Einstieg',
            intermediate: 'Vertiefung',
            advanced: 'Spezialisierung',
        },
        form: {
            title: 'Titel',
            slug: 'Slug',
            slugHelp: 'URL-freundlicher Bezeichner (z.B. einfuehrung-javascript)',
            description: 'Beschreibung',
            estimatedDuration: 'Geschätzte Dauer (Minuten)',
            difficulty: 'Schwierigkeitsgrad',
            requireSequentialCompletion: 'Sequenzieller Abschluss erforderlich',
            active: 'Aktiv',
            tags: 'Tags',
            tagsHelp: 'Komma-getrennte Liste (z.B. react, javascript, frontend)',
            certificateType: 'Zertifikat für den Kursabschluss',
            certificateTypeParticipated: 'Zertifikat: Am Kurs teilgenommen',
            certificateTypePassed: 'Zertifikat: Kurs erfolgreich bestanden',
            certificateTypeNone: 'Kein Zertifikat ausstellen',
            certificateTypeRequired: 'Bitte festlegen, welches Zertifikat der Kurs ausstellt.',
            certificateTypePassedWithoutThreshold: 'Keine Lektion hat eine Mindestpunktzahl – jeder Abschluss gilt als bestanden. Die Mindestpunktzahl legst du pro Lektion fest.',
            aiTutorEnabled: 'KI-Lernassistent aktivieren',
            requireTeacherReviewForGrading: 'KI-Bewertungen erfordern Freigabe durch eine berechtigte Person (zertifikats-relevante Kurse)',
        },
    },
    catalogs: {
        title: 'Kursverwaltung',
        loading: 'Lade Kataloge...',
        loadError: 'Fehler beim Laden der Kataloge',
        newCatalog: 'Neuer Katalog',
        editCatalog: 'Katalog bearbeiten',
        manageCourses: 'Kurse verwalten',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        coursesCount: '%{count} Kurse',
        created: 'Erstellt',
        confirmDelete: 'Möchten Sie diesen Katalog wirklich löschen?',
        updateSuccess: 'Katalog erfolgreich aktualisiert',
        createSuccess: 'Katalog erfolgreich erstellt',
        deleteSuccess: 'Katalog erfolgreich gelöscht',
        saveError: 'Fehler beim Speichern des Katalogs',
        deleteError: 'Fehler beim Löschen des Katalogs',
        form: {
            name: 'Name',
            description: 'Beschreibung',
            active: 'Aktiv',
        },
    },
    blockEditor: {
        ariaLabel: 'Lektionsinhalt',
        loading: 'Editor wird geladen …',
        placeholder: {
            richtext: 'Schreib etwas oder tippe „/“ für Blöcke …',
            heading: 'Überschrift …',
            quote: 'Zitat eingeben …',
            code: '// Code hier schreiben …',
        },
        toolbar: {
            undo: 'Rückgängig',
            redo: 'Wiederholen',
            bold: 'Fett',
            italic: 'Kursiv',
            underline: 'Unterstrichen',
            strike: 'Durchgestrichen',
            link: 'Link',
        },
        library: {
            title: 'Block-Bibliothek',
            toggle: 'Blöcke',
            close: 'Block-Bibliothek schließen',
            search: 'Blöcke durchsuchen …',
            empty: 'Keine Blöcke passend zu „%{query}“',
            hint: 'Tipp: Tippe „/“ im Text, um schnell einen Block einzufügen.',
        },
        slash: {
            title: 'Block einfügen',
            results: '%{smart_count} Treffer für „%{query}“ |||| %{smart_count} Treffer für „%{query}“',
        },
        actions: {
            toolbar: 'Block-Aktionen',
            drag: 'Zum Verschieben ziehen',
            switchType: 'Blocktyp wechseln',
            convertTo: 'Umwandeln in …',
            noMatch: 'Keine passenden Blocktypen',
            moveUp: 'Nach oben verschieben',
            moveDown: 'Nach unten verschieben',
            duplicate: 'Block duplizieren',
            delete: 'Block löschen',
        },
        views: {
            loadingMedia: 'Medium wird geladen …',
            pickFromLibrary: 'Aus Medienbibliothek wählen',
            replace: 'Ersetzen',
            explanation: 'Erklärung (optional)',
            explanationHint: 'Wird Lernenden nach dem Beantworten angezeigt.',
            video: { empty: 'Noch kein Video gewählt', poster: 'Vorschaubild', posterChange: 'Vorschaubild ändern', posterRemove: 'Vorschaubild entfernen', chapters: '%{smart_count} Kapitelmarke |||| %{smart_count} Kapitelmarken', addChapter: 'Kapitel', seconds: 'Sekunde', chapterTitle: 'Kapiteltitel' },
            audio: { empty: 'Noch keine Audiodatei gewählt', title: 'Titel' },
            file: { empty: 'Noch keine Datei gewählt', unnamed: 'Unbenannte Datei' },
            pdf: { empty: 'Noch kein PDF gewählt' },
            embed: { empty: 'URL eines YouTube- oder Vimeo-Videos eintragen', linkOnly: 'Unbekannter Anbieter – Lernende sehen einen Link: %{url}', url: 'URL', ratio: 'Format' },
            table: { header: 'Kopfzeile', addRow: 'Zeile', addColumn: 'Spalte hinzufügen', removeRow: 'Zeile entfernen', removeColumn: 'Spalte entfernen', headerPlaceholder: 'Spalte %{n}', caption: 'Tabellenbeschriftung (optional)' },
            timeline: { entries: '%{smart_count} Eintrag |||| %{smart_count} Einträge', add: 'Eintrag', date: 'Datum oder Zeitraum', title: 'Titel', description: 'Beschreibung' },
            quiz: { single: 'Quiz (eine Antwort)', multi: 'Quiz (mehrere Antworten)', multiSelect: 'Mehrere Antworten', question: 'Frage', option: 'Antwort %{n}', addOption: 'Antwort', removeOption: 'Antwort entfernen', markCorrect: 'Als richtig markieren', markedCorrect: 'Als richtig markiert' },
            fillBlank: { count: '%{smart_count} Lücke |||| %{smart_count} Lücken', insert: 'Lücke', template: 'Text mit Lücken', templateHint: 'Lücken als {{blank_1}} schreiben oder über „Lücke“ einfügen.', answers: 'Akzeptierte Antworten je Lücke (durch Komma getrennt)', answersPlaceholder: 'Antwort 1, Antwort 2, …', caseSensitive: 'Groß/Klein', remove: 'Lücke entfernen' },
            matching: { count: '%{smart_count} Paar |||| %{smart_count} Paare', add: 'Paar', left: 'Linke Seite', right: 'Rechte Seite', term: 'Begriff %{n}', match: 'Zuordnung %{n}', remove: 'Paar entfernen', shuffleHint: 'Die rechte Seite wird Lernenden gemischt angezeigt.' },
            ordering: { hint: 'In der richtigen Reihenfolge eingeben', add: 'Element', step: 'Schritt %{n}', remove: 'Element entfernen', shuffleHint: 'Die Elemente werden Lernenden gemischt angezeigt.' },
            flashcard: { count: '%{smart_count} Karte |||| %{smart_count} Karten', add: 'Karte', card: 'Karte %{n}', front: 'Vorderseite', back: 'Rückseite', remove: 'Karte entfernen' },
            poll: { question: 'Umfragefrage', option: 'Option %{n}', addOption: 'Option', removeOption: 'Option entfernen', multiSelect: 'Mehrfachauswahl', showResults: 'Ergebnisse anzeigen' },
            stage: { choose: 'Bild wählen', replace: 'Bild ersetzen', clickHint: 'Klick ins Bild setzt einen neuen Punkt.' },
            hotspot: { count: '%{smart_count} Bereich |||| %{smart_count} Bereiche', empty: 'Bild aus der Medienbibliothek wählen, dann Bereiche markieren.', label: 'Beschriftung', description: 'Beschreibung', add: 'Bereich', remove: 'Bereich entfernen' },
            labeling: { count: '%{smart_count} Punkt |||| %{smart_count} Punkte', empty: 'Bild wählen, dann die zu benennenden Punkte setzen.', text: 'Erwartete Beschriftung', add: 'Punkt', remove: 'Punkt entfernen' },
            sorting: { category: 'Kategorie', newCategory: 'Kategorie %{n}', addCategory: 'Kategorie', removeCategory: 'Kategorie entfernen', item: 'Element %{n}', addItem: 'Element', removeItem: 'Element entfernen' },
            sliderScale: { question: 'Frage oder Aussage', minLabel: 'Beschriftung Minimum', maxLabel: 'Beschriftung Maximum', min: 'Minimum', max: 'Maximum', step: 'Schritt' },
            discussion: { prompt: 'Diskussionsimpuls', allowReplies: 'Antworten erlauben', moderation: 'Moderation erforderlich' },
            branching: { count: '%{smart_count} Knoten |||| %{smart_count} Knoten', start: 'Startknoten', startChip: 'Start', addNode: 'Knoten', removeNode: 'Knoten entfernen', question: 'Frage oder Situation', option: 'Option', next: 'Weiter zu', end: '— Ende —', addOption: 'Option', removeOption: 'Option entfernen' },
            simulation: { count: '%{smart_count} Schritt |||| %{smart_count} Schritte', scenario: 'Szenario', addStep: 'Schritt', removeStep: 'Schritt entfernen', stepText: 'Situation / Entscheidungspunkt', choice: 'Auswahl', correct: 'Richtig', feedback: 'Feedback zu dieser Auswahl', addChoice: 'Auswahl', removeChoice: 'Auswahl entfernen' },
            scorm: { title: 'Titel', version: 'SCORM-Version', empty: 'Noch kein Paket – ZIP hochladen oder aus der Medienbibliothek wählen; es wird automatisch entpackt.', attached: 'Paket „%{title}“ ist bereit.', upload: 'Paket hochladen', replace: 'Ersetzen', library: 'Medienbibliothek', processing: 'Paket wird verarbeitet …', ready: 'SCORM-Paket bereit.', extractError: 'Das Paket konnte nicht entpackt werden.', uploadError: 'Upload fehlgeschlagen.', zipOnly: 'Bitte ein SCORM-Paket als .zip wählen.' },
            h5p: { title: 'Titel', embedUrl: 'Einbettungs-URL (optional)', embedHint: 'Leer lassen, wenn der Inhalt im H5P-Editor erstellt wird.', create: 'H5P-Inhalt erstellen', edit: 'H5P-Inhalt bearbeiten', attached: 'H5P-Inhalt #%{id} verknüpft.', empty: 'Noch kein H5P-Inhalt.' },
            columns: { choose: 'Spalten-Layout wählen', preset: { '2': '2 gleich', '3': '3 gleich', '2-1': '2/3 + 1/3', '1-2': '1/3 + 2/3' }, count: '%{smart_count} Spalte |||| %{smart_count} Spalten', changeLayout: 'Layout ändern', add: 'Spalte', column: 'Spalte %{n}', remove: 'Spalte entfernen' },
            accordion: { count: '%{smart_count} Abschnitt |||| %{smart_count} Abschnitte', allowMultiple: 'Mehrere offen', add: 'Abschnitt', newItem: 'Abschnitt %{n}', titlePlaceholder: 'Titel des Abschnitts …', defaultOpen: 'Offen', expand: 'Aufklappen', collapse: 'Zuklappen', remove: 'Abschnitt entfernen' },
            tabs: { count: '%{smart_count} Tab |||| %{smart_count} Tabs', add: 'Tab', newTab: 'Tab %{n}', label: 'Beschriftung', remove: 'Tab entfernen' },
        },
        categories: { content: 'Inhalt', layout: 'Layout', interactive: 'Interaktiv' },
        callout: {
            placeholder: 'Text der Hinweisbox eingeben …',
            variant: 'Art',
            text: 'Text',
            htmlHint: 'Einfaches HTML erlaubt (<p>, <strong>, <a>)',
            variants: { info: 'Info', warning: 'Warnung', success: 'Erfolg', danger: 'Achtung', tip: 'Tipp' },
        },
        image: {
            empty: 'Noch kein Bild gewählt',
            fromLibrary: 'Aus Medienbibliothek wählen',
            replace: 'Bild ersetzen',
            alt: 'Alternativtext',
            caption: 'Bildunterschrift',
            alignment: { label: 'Ausrichtung', left: 'Links', center: 'Mittig', right: 'Rechts' },
        },
        types: {
            richtext: { label: 'Text', description: 'Einfacher Textabsatz' },
            heading1: { label: 'Überschrift 1', description: 'Große Abschnittsüberschrift' },
            heading2: { label: 'Überschrift 2', description: 'Mittlere Abschnittsüberschrift' },
            heading3: { label: 'Überschrift 3', description: 'Kleine Abschnittsüberschrift' },
            image: { label: 'Bild', description: 'Bild aus der Medienbibliothek' },
            quote: { label: 'Zitat', description: 'Zitatblock mit Quellenangabe' },
            code: { label: 'Code', description: 'Codeblock mit fester Schrift' },
            divider: { label: 'Trennlinie', description: 'Horizontale Trennlinie' },
            callout: { label: 'Hinweisbox', description: 'Hervorgehobene Info-, Warn- oder Tipp-Box' },
            video: { label: 'Video', description: 'Video aus der Medienbibliothek' },
            audio: { label: 'Audio', description: 'Audiodatei einbetten' },
            file: { label: 'Datei', description: 'Datei zum Herunterladen anhängen' },
            embed: { label: 'Einbettung', description: 'Externe Inhalte einbetten (YouTube, Vimeo …)' },
            timeline: { label: 'Zeitstrahl', description: 'Zeitstrahl mit datierten Ereignissen' },
            pdf_viewer: { label: 'PDF', description: 'PDF-Dokument einbetten' },
            columns: { label: 'Spalten', description: 'Mehrspaltiges Layout (2–4 Spalten)' },
            accordion: { label: 'Akkordeon', description: 'Auf- und zuklappbare Inhaltsbereiche' },
            tabs: { label: 'Tabs', description: 'Inhalte in Reitern anordnen' },
            table: { label: 'Tabelle', description: 'Datentabelle mit optionaler Kopfzeile' },
            inline_quiz: { label: 'Quiz', description: 'Multiple-Choice-Frage im Inhalt' },
            fill_blank: { label: 'Lückentext', description: 'Text mit Lücken zum Ausfüllen' },
            matching: { label: 'Zuordnung', description: 'Paare einander zuordnen' },
            ordering: { label: 'Reihenfolge', description: 'Elemente in die richtige Reihenfolge bringen' },
            flashcard: { label: 'Karteikarten', description: 'Umdrehbare Karten zum Einprägen' },
            poll: { label: 'Umfrage', description: 'Umfrage- oder Abstimmungsfrage' },
            discussion: { label: 'Diskussion', description: 'Diskussionsimpuls für Teilnehmende' },
            slider_scale: { label: 'Skala', description: 'Selbsteinschätzung mit Bewertungsskala' },
            sorting: { label: 'Sortieren', description: 'Elemente in Gruppen einordnen' },
            hotspot: { label: 'Hotspot', description: 'Bild mit klickbaren Bereichen' },
            labeling: { label: 'Beschriftung', description: 'Punkte auf einem Bild beschriften' },
            h5p: { label: 'H5P-Inhalt', description: 'Interaktive H5P-Inhalte einbetten' },
            scorm_embed: { label: 'SCORM-Paket', description: 'SCORM-Lernpaket einbetten' },
            code_sandbox: { label: 'Code-Sandbox', description: 'Interaktive Programmieraufgabe' },
            branching: { label: 'Verzweigung', description: 'Entscheidungsbaum mit verzweigten Pfaden' },
            simulation: { label: 'Simulation', description: 'Entscheidungsszenario mit Konsequenzen' },
            photo_task: { label: 'Foto-Aufgabe', description: 'Foto vom Arbeitsplatz, geprüft gegen Kriterien' },
        },
    },
    mediaPicker: {
        title: { image: 'Bild auswählen', video: 'Video auswählen', audio: 'Audio auswählen', document: 'Dokument auswählen', any: 'Datei auswählen' },
        search: 'Dateien durchsuchen …',
        upload: 'Hochladen',
        empty: 'Keine passenden Dateien in der Medienbibliothek',
        loadError: 'Medienbibliothek konnte nicht geladen werden',
        uploadSuccess: 'Datei hochgeladen',
        uploadError: 'Upload fehlgeschlagen',
    },
    blockLesson: {
        preview: { show: 'Vorschau', edit: 'Bearbeiten' },
        saveError: 'Lektion konnte nicht gespeichert werden',
        shortcutsHint: 'Tipp: „/“ öffnet das Block-Menü, Strg+S speichert sofort. Änderungen werden automatisch gesichert.',
        minScore: 'Mindestpunktzahl (%)',
        minScoreHint: 'Standard: 70 %',
        status: {
            idle: 'Gespeichert',
            unsaved: 'Ungespeicherte Änderungen',
            saving: 'Speichert …',
            saved: 'Gespeichert',
            savedAt: 'Gespeichert %{time}',
            error: 'Speichern fehlgeschlagen',
        },
        completionRule: {
            label: 'Abschlussregel',
            hint: 'Legt fest, wann Lernende die Lektion abschließen dürfen.',
            view_only: 'Ansehen genügt',
            scroll_through: 'Bis zum Ende lesen',
            all_interactions: 'Alle Übungen bearbeiten',
            quiz_passed: 'Mindestpunktzahl erreichen',
            manual: 'Manuell abschließen',
        },
        versions: {
            title: 'Versionen',
            empty: 'Noch keine früheren Versionen',
            version: 'Version %{version}',
            blocks: '%{smart_count} Block |||| %{smart_count} Blöcke',
            restore: 'Wiederherstellen',
            confirmRestore: 'Version %{version} wiederherstellen? Der aktuelle Stand wird vorher als Version gesichert.',
            restored: 'Version %{version} wiederhergestellt',
            restoreError: 'Version konnte nicht wiederhergestellt werden',
            loadError: 'Versionen konnten nicht geladen werden',
            commentPlaceholder: 'Versionsbeschreibung, z. B. „Bild geändert“',
            saveNamed: 'Version sichern',
            saved: 'Version gesichert',
            saveError: 'Version konnte nicht gesichert werden',
            retention: 'Aufeinanderfolgende automatische Speicherungen werden zusammengefasst. Es werden höchstens %{max} Versionen aufbewahrt, ältere fallen weg – benannte Versionen zuletzt.',
            source: { autosave: 'Automatisch', manual: 'Manuell', pre_restore: 'Vor Wiederherstellung' },
        },
    },
    courseBuilder: {
        classicLesson: { hint: 'Diese Lektion (z. B. Freitext-Fragen aus dem KI-Generator) nutzt das klassische Format und lässt sich nicht im Block-Editor bearbeiten.', open: 'Klassischen Editor öffnen' },
        quality: 'KI-Qualität',
        sources: 'Quellen',
        sourcesDialog: { title: 'Zitierte Quellen', empty: 'Dieser Kurs zitiert keine Quellen aus der Wissensbasis.', count: '%{count} Quellen in %{lessons} Lektionen', retired: 'Quelle ersetzt – Lektion prüfen', page: 'S. %{page}' },
        format: {
            label: 'Inhaltsformat',
            classic: 'Klassisch (Bestandstypen)',
            blocks: 'Autorentool v2 (Sektionen + Blöcke)',
        },
        title: 'Kurs-Builder – %{title}',
        badge: 'Autorentool v2',
        inactive: 'Nicht aktiv',
        structure: 'Kursstruktur',
        loadError: 'Kurs konnte nicht geladen werden',
        reorderError: 'Reihenfolge konnte nicht gespeichert werden',
        empty: {
            title: 'Lektion auswählen',
            hint: 'Wähle links eine Lektion aus oder lege in einer Sektion eine neue Lektion an.',
        },
        section: {
            add: 'Sektion',
            rename: 'Sektion umbenennen',
            titleField: 'Titel der Sektion',
            untitled: 'Neue Sektion',
            empty: 'Noch keine Sektionen. Lege zuerst eine Sektion an, dann Lektionen darin.',
            unassigned: 'Ohne Sektion',
            notEmpty: 'Die Sektion enthält noch Lektionen. Bitte zuerst verschieben oder löschen.',
            confirmDelete: 'Sektion „%{title}“ löschen?',
            saveError: 'Sektion konnte nicht gespeichert werden',
            deleteError: 'Sektion konnte nicht gelöscht werden',
        },
        lesson: {
            add: 'Lektion',
            edit: 'Lektion bearbeiten',
            move: 'Verschieben nach …',
            menu: 'Lektionsmenü',
            titleField: 'Titel der Lektion',
            duration: 'Dauer (Minuten)',
            untitled: 'Neue Lektion',
            blocks: '%{smart_count} Block |||| %{smart_count} Blöcke',
            saveError: 'Lektion konnte nicht gespeichert werden',
        },
    },
    aiGenerator: {
        pageTitle: 'KI-Generator',
        badge: 'KI-Suite',
        modes: { label: 'Generator wählen', content: 'Bausteine', course: 'Ganzer Kurs' },
        knowledge: { use: 'Wissensbasis nutzen', hint: 'Die KI belegt Aussagen mit Quellen aus der Wissensbasis und zitiert sie je Lektion.', sources: 'Nur diese Quellen (leer = alle)', sourcesLabel: 'Quellen', none: 'Keine Quellen verfügbar – Quellen werden unter Wissensbasis angelegt.', cited: 'Quellen: %{count}' },
        quota: {
            content: 'Heute %{used} von %{limit} Baustein-Jobs',
            course: 'Heute %{used} von %{limit} Kurs-Generierungen',
            exhausted: 'Das Tageslimit Ihres Unternehmens ist erreicht. Morgen geht es weiter – oder der Operator hebt das Limit an.',
        },
        material: {
            mode: 'Quelle wählen',
            text: 'Text',
            url: 'Webseite',
            file: 'Datei',
            urlField: 'Adresse der Webseite',
            fetch: 'Text laden',
            fetched: 'Webseite geladen (%{chars} Zeichen).',
            fetchError: 'Die Webseite konnte nicht geladen werden.',
            chooseFile: 'PDF, DOCX oder PPTX wählen',
            fileHint: 'Max. 15 MB – die Datei wird nicht gespeichert, nur der Text übernommen.',
            extracted: 'Text aus der Datei übernommen (%{chars} Zeichen).',
            extractError: 'Aus der Datei konnte kein Text gelesen werden.',
            textField: 'Quellmaterial',
            chars: '%{chars} Zeichen (mind. %{min})',
            charsOptional: '%{chars} Zeichen – optional, solange die Wissensbasis genutzt wird: leer lassen für die gewählten Quellen oder kurz das Thema nennen.',
            source: 'Quelle: %{source}',
            truncated: 'Gekürzt auf die maximale Länge.',
        },
        fields: { language: 'Sprache', difficulty: 'Schwierigkeit', difficultyAny: 'Keine Vorgabe' },
        difficulty: { beginner: 'Einsteiger', intermediate: 'Fortgeschritten', advanced: 'Experte' },
        types: {
            lesson_draft: 'Lektionsentwurf (Blöcke)',
            summary: 'Zusammenfassung',
            key_points: 'Kernpunkte',
            flashcards: 'Lernkarten',
            multiple_choice: 'Multiple-Choice-Fragen',
            true_false: 'Wahr/Falsch-Fragen',
            free_text_question: 'Freitext-Fragen',
        },
        sources: { plain_text: 'Text', url: 'Webseite', existing_course: 'Bestehender Kurs', pdf: 'PDF', docx: 'DOCX', pptx: 'PPTX' },
        status: { pending: 'Wartet', processing: 'Läuft', completed: 'Fertig', failed: 'Fehlgeschlagen' },
        contentStatus: { pending: 'Zu prüfen', accepted: 'Übernommen', rejected: 'Verworfen' },
        content: {
            title: 'Bausteine aus Material erzeugen',
            intro: 'Text einfügen, Webseite laden oder Datei hochladen – die KI erzeugt daraus Bausteine, die Sie prüfen und in einen Kurs übernehmen.',
            types: 'Was soll erzeugt werden?',
            noTypes: 'Bitte mindestens einen Typ wählen.',
            submit: 'Bausteine erzeugen',
            created: 'Auftrag gestartet – das Ergebnis erscheint in der Liste.',
            createError: 'Der Auftrag konnte nicht gestartet werden.',
        },
        course: {
            title: 'Ganzen Kurs entwerfen',
            intro: 'Thema und Lernziel beschreiben – die KI plant Sektionen und Lektionen mit Wissens-Checks und legt einen inaktiven Kurs-Entwurf an, den Sie im Builder prüfen.',
            topic: 'Thema',
            goal: 'Zielgruppe und Lernziel',
            goalPlaceholder: 'z. B. Neue Mitarbeitende im Lager sollen Leitern sicher aufstellen und prüfen können.',
            catalog: 'Zielkatalog',
            noCatalogs: 'Kein Kurskatalog vorhanden – bitte zuerst einen Katalog anlegen.',
            material: 'Optional: Quellmaterial, auf dem der Kurs aufbauen soll',
            submit: 'Kurs-Entwurf erzeugen',
            created: 'Kurs-Generierung gestartet – der Fortschritt erscheint in der Liste.',
            createError: 'Die Kurs-Generierung konnte nicht gestartet werden.',
        },
        jobs: {
            title: 'Aufträge',
            refresh: 'Aktualisieren',
            empty: 'Noch keine Aufträge.',
            loadError: 'Aufträge konnten nicht geladen werden.',
            contentJob: 'Auftrag #%{id}',
            items: '%{smart_count} Ergebnis |||| %{smart_count} Ergebnisse',
            failed: 'Der Auftrag ist fehlgeschlagen.',
            openBuilder: 'Im Builder öffnen',
        },
        results: {
            title: 'Ergebnisse von Auftrag #%{id}',
            empty: 'Der Auftrag hat keine Ergebnisse geliefert.',
            preview: 'Vorschau',
            hidePreview: 'Vorschau schließen',
            previewError: 'Die Vorschau konnte nicht erzeugt werden.',
            sampleAnswer: 'Musterantwort',
            accept: 'Übernehmen',
            reject: 'Verwerfen',
            rejected: 'Ergebnis verworfen.',
            rejectError: 'Das Ergebnis konnte nicht verworfen werden.',
            acceptTitle: 'In Kurs übernehmen',
            acceptHint: 'Der Baustein wird als neue Lektion angelegt oder an eine bestehende Lektion des Kurses angehängt. In v2-Kursen landet eine neue Lektion in der gewählten Sektion oder in „KI-Entwürfe“.',
            targetLesson: 'Ziellektion',
            newLesson: 'Neue Lektion anlegen',
            source: 'Auftrag',
            targetCourse: 'Zielkurs',
            targetSection: 'Sektion',
            draftSection: 'Sektion „KI-Entwürfe“ (wird angelegt)',
            accepted: 'Lektion „%{lesson}“ wurde in „%{course}“ angelegt.',
            acceptError: 'Die Übernahme ist fehlgeschlagen.',
            openLesson: 'Lektion öffnen',
        },
    },
    courseQuality: {
        title: 'KI-Qualitätsprüfung',
        badge: 'v2',
        back: 'Zurück zum Kurs',
        start: 'Neue Analyse starten',
        started: 'Analyse gestartet – das Ergebnis erscheint in Kürze.',
        startError: 'Die Analyse konnte nicht gestartet werden.',
        loadError: 'Qualitätsdaten konnten nicht geladen werden.',
        disclaimer: 'Der Score ist eine KI-Einschätzung von Struktur, Texten und Fragen. Mediale Qualität (Videos, SCORM, H5P) wird nicht bewertet – bitte redaktionell prüfen.',
        running: 'Analyse läuft … Das dauert üblicherweise 30–90 Sekunden.',
        failed: 'Die Analyse ist fehlgeschlagen: %{error}',
        empty: { title: 'Noch keine Analyse', hint: 'Starte eine KI-Qualitätsanalyse, um Score und Verbesserungsvorschläge zu erhalten.' },
        overall: 'Gesamtscore',
        checkedAt: 'Geprüft am %{date}',
        model: 'Modell: %{model}',
        radarLabel: 'Qualitäts-Radar über %{count} Dimensionen',
        notApplicable: 'n. z.',
        dimensions: {
            structure: 'Struktur',
            content_depth: 'Inhaltliche Tiefe',
            engagement: 'Engagement',
            accessibility: 'Barrierefreiheit',
            assessment_coverage: 'Wissensprüfung',
            compliance: 'Pflichtinhalte',
            readability: 'Lesbarkeit',
            learner_data: 'Lernendendaten',
        },
        learnerData: {
            title: 'Lernendendaten',
            hint: 'So läuft der Kurs in der Praxis: Abschlussquote, Ergebnisse und an welcher Lektion Lernende aussteigen. Diese Zahlen hat die KI bei ihren Empfehlungen gesehen.',
            insufficient: 'Erst %{count} Einschreibung(en) – ab 5 fließen Lernendendaten in die Prüfung ein.',
            enrollments: 'Einschreibungen',
            completionRate: 'Abschlussquote',
            inProgress: 'In Bearbeitung',
            avgScore: 'Ø Ergebnis',
            avgTime: 'Ø Lernzeit',
            minutes: '%{minutes} min',
            funnel: 'Lektions-Trichter',
            started: 'begonnen',
            completed: 'abgeschlossen',
            exit: '%{rate} % steigen davor aus',
            score: 'Ø %{score}',
            dropOff: 'Ausstieg',
            lowScore: 'Niedriges Ergebnis',
        },
        suggestions: 'Verbesserungsvorschläge',
        strengths: 'Stärken',
        affected: 'Betrifft: %{lessons}',
        severity: { high: 'Hoch', medium: 'Mittel', low: 'Niedrig' },
        compliance: {
            title: 'Pflichtinhalte der Unterweisung',
            covered: '%{covered} von %{total} abgedeckt',
            hint: 'Mindestinhalte nach DGUV Vorschrift 1 § 4 und ArbSchG § 12. Nicht abgedeckte Punkte vor dem Einsatz als Unterweisung ergänzen.',
            in: 'in: %{evidence}',
            missing: 'fehlt',
            items: {
                hazards: 'Gefährdungen am Arbeitsplatz',
                protective_measures: 'Schutzmaßnahmen und Verhaltensregeln',
                ppe: 'Persönliche Schutzausrüstung',
                disturbances_emergencies: 'Verhalten bei Störungen und Notfällen',
                first_aid: 'Erste Hilfe und Notruf',
                escape_routes: 'Flucht- und Rettungswege',
                responsibilities: 'Zuständigkeiten und Meldewege',
                legal_basis: 'Rechtsgrundlage / Betriebsanweisung genannt',
            },
        },
        readability: {
            title: 'Lesbarkeit',
            badge: 'Lesestufe %{grade} · %{score}/100',
            hint: 'Wiener Sachtextformel je Lektion. Für Unterweisungen sollte die Lesestufe unter 8 liegen; ab 10 lohnt sich Kürzen.',
            words: '%{words} Wörter',
            grade: 'Stufe %{grade}',
        },
        history: 'Frühere Analysen',
        historyRow: 'Score %{score}/100 · %{status}',
        status: { pending: 'Wartet', processing: 'Läuft', completed: 'Fertig', failed: 'Fehlgeschlagen' },
    },
    provenance: {
        title: 'Herkunft und Freigabe',
        origin: { manual: 'Manuell erstellt', generated: 'KI-generiert', assisted: 'Manuell erstellt, KI-Inhalte übernommen', variant: 'KI-Variante (Übersetzung / Leichte Sprache)' },
        generatedBy: 'Erzeugt von',
        model: 'Modell',
        promptVersion: 'Prompt-Version',
        material: 'Quellmaterial',
        materialInfo: '%{chars} Zeichen · SHA-256 %{hash}…',
        noMaterial: 'kein hochgeladenes Material',
        derivedFrom: 'Abgeleitet von Kurs',
        lastQuality: 'Letzte Qualitätsprüfung: %{score}/100 am %{date}',
        gateHint: 'Ihr Unternehmen verlangt für KI-generierte Kurse eine fachliche Freigabe, bevor sie aktiviert werden können.',
        signedBy: 'Freigegeben von %{name} am %{date}',
        changedSince: 'Der Inhalt wurde seit der Freigabe geändert – bitte erneut prüfen.',
        signOffAgain: 'Erneut freigeben',
        withdraw: 'Freigabe zurückziehen',
        notSigned: 'Noch nicht fachlich freigegeben',
        signHint: 'Mit der Freigabe bestätigen Sie, dass Sie den aktuellen Kursinhalt fachlich geprüft haben. Spätere Änderungen werden als „geändert seit Freigabe“ markiert.',
        note: 'Anmerkung (optional)',
        signOff: 'Kurs freigeben',
        signedOff: 'Kurs freigegeben.',
        withdrawn: 'Freigabe zurückgezogen.',
        actionError: 'Aktion fehlgeschlagen.',
        badge: { generated: 'KI-generiert', assisted: 'KI-unterstützt', variant: 'KI-Variante', signedOff: 'Freigegeben' },
    },
    knowledgeBase: {
        pageTitle: 'Wissensbasis',
        platformTitle: 'Plattform-Wissensbasis',
        intro: 'Betriebsanweisungen, Gefährdungsbeurteilungen, Verfahrensanweisungen und Regelwerke, auf die sich KI-Generator und KI-Tutor stützen. Jede Quelle wird in Abschnitte zerlegt und durchsuchbar gemacht.',
        platformIntro: 'Quellen ohne Unternehmen (allgemeine Regelwerke wie ArbSchG, DGUV) – für alle Unternehmen lesbar, nur hier verwaltet.',
        embeddingsOff: 'Kein Embedding-Endpunkt konfiguriert – die Suche arbeitet rein lexikalisch. Sobald der Endpunkt aktiv ist, Quellen neu verarbeiten.',
        platformCount: 'Plattform-Quellen verfügbar: %{count}',
        add: { title: 'Quelle hinzufügen', file: 'Datei', url: 'Webseite', text: 'Text', fileHint: 'PDF, DOCX, PPTX, Markdown oder Text, max. 25 MB', urlLabel: 'Adresse (https://…)', textLabel: 'Text einfügen', submit: 'Quelle anlegen', created: 'Quelle angelegt – die Verarbeitung läuft im Hintergrund.' },
        fields: { title: 'Titel', publisher: 'Herausgeber', documentNumber: 'Dokumentnummer', jurisdiction: 'Rechtsraum', license: 'Lizenzklasse', validFrom: 'Stand (Datum)', supersedes: 'Ersetzt Vorgängerversion' },
        license: { internal: 'Intern', official_work: 'Amtliches Werk', public_domain: 'Gemeinfrei', public_copyrighted: 'Öffentlich, urheberrechtlich geschützt', licensed: 'Lizenziert' },
        licenseHint: 'Bei „Intern“, „Amtliches Werk“ und „Gemeinfrei“ darf die KI wörtlich zitieren, sonst nur paraphrasieren.',
        status: { pending: 'Wartet', processing: 'Wird verarbeitet', ready: 'Bereit', failed: 'Fehlgeschlagen' },
        list: { empty: 'Noch keine Quellen.', chunks: '%{count} Abschnitte', characters: '%{count} Zeichen', version: 'Version %{version}', retired: 'Ersetzt', references: 'In %{count} Lektionen zitiert', noEmbeddings: 'ohne Embeddings', reingest: 'Neu verarbeiten', delete: 'Löschen', confirmDelete: 'Quelle „%{title}“ und alle Abschnitte löschen? Zitate in Lektionen verlieren ihre Quelle.', deleted: 'Quelle gelöscht.', reingested: 'Verarbeitung gestartet.' },
        search: { title: 'Suche testen', placeholder: 'Suchbegriff oder Frage …', button: 'Suchen', empty: 'Keine Treffer.', hint: 'So sieht der Generator die Wissensbasis – die besten Abschnitte werden als Referenzen [S1], [S2] … in den Prompt übernommen.' },
        errors: { duplicate: 'Dieses Dokument ist bereits vorhanden.', generic: 'Die Quelle konnte nicht angelegt werden.' },
    },
    helpBot: {
        title: 'Hilfe-Assistent',
        aiLabel: 'KI',
        intro: 'Ich erkläre dir die Bedienung der online:academy. Inhaltliche Fragen zu einem Kurs beantwortet der KI-Tutor im Kursplayer.',
        placeholder: 'Wie kann ich …?',
        send: 'Senden',
        close: 'Schließen',
        clear: 'Verlauf leeren',
        error: 'Der Hilfe-Assistent ist gerade nicht erreichbar.',
        disclaimer: 'KI-generierte Antworten können Fehler enthalten. Der Verlauf wird nicht gespeichert.',
        suggestions: { start: 'Wie lege ich los?', certificates: 'Wo finde ich meine Zertifikate?', notifications: 'Welche Benachrichtigungen gibt es?', player: 'Wie funktioniert der Kursplayer?', notes: 'Wie schreibe ich eine Notiz?', tutor: 'Was kann der KI-Tutor?', enroll: 'Wie schreibe ich mich in einen Kurs ein?', assignments: 'Was ist eine Pflichtaufgabe?', createCourse: 'Wie erstelle ich einen Kurs?', lessons: 'Welche Lektionstypen gibt es?', aiGenerator: 'Wie nutze ich den KI-Generator?', assignmentCreate: 'Wie vergebe ich eine Pflichtaufgabe?', reminders: 'Wie stelle ich Erinnerungen ein?', overdue: 'Wie sehe ich überfällige Aufgaben?', knowledgeBase: 'Wofür ist die Wissensbasis?', aiSettings: 'Was steuern die KI-Einstellungen?', invite: 'Wie lade ich Benutzer ein?', roles: 'Welche Rollen gibt es?', branding: 'Wie ändere ich Logo und Farben?' },
    },
    variants: {
        button: 'Varianten',
        title: 'Sprachvarianten und Leichte Sprache',
        family: 'Kursfamilie',
        original: 'Original',
        inactive: 'inaktiv',
        outdated: 'Veraltet – Original geändert',
        reviewRequired: 'Redaktion erforderlich',
        open: 'Öffnen',
        jobs: 'Erzeugungen',
        create: 'Neue Variante erzeugen',
        fromOriginal: 'Varianten werden vom Original „%{title}“ abgeleitet.',
        kindLabel: 'Art',
        kind: { translation: 'Übersetzung', easy_language: 'Leichte Sprache' },
        language: 'Zielsprache',
        submit: 'Variante erzeugen',
        started: 'Variante wird erzeugt – der Fortschritt erscheint in der Liste.',
        createError: 'Die Variante konnte nicht gestartet werden.',
        loadError: 'Varianten konnten nicht geladen werden.',
        status: { pending: 'Wartet', processing: 'Läuft', completed: 'Fertig', failed: 'Fehlgeschlagen' },
        skipped: '%{count} Lektion(en) unverändert übernommen',
        reviewHint: 'In dieser Sprache ist das KI-Modell schwächer: Die Variante bleibt inaktiv, bis sie redaktionell geprüft und freigegeben ist.',
        hint: 'Die Variante entsteht als eigener, inaktiver Kurs mit gleicher Struktur, übernimmt Einstellungen und Quellenangaben und wird im Katalog beim Original verlinkt. Ändert sich das Original später, erscheint „Veraltet“.',
        availableIn: 'Auch verfügbar in',
    },
    aiSettings: {
        title: 'KI-Einstellungen',
        intro: 'Welche KI-Funktionen Ihr Unternehmen nutzt, ob KI-generierte Kurse vor der Aktivierung freigegeben werden müssen, und wie der KI-Tutor angesprochen wird.',
        company: 'Mandant',
        companyHint: 'Als Betreiber wählen Sie das Unternehmen über seine ID.',
        companyId: 'Unternehmens-ID',
        features: 'Funktionen',
        switch: {
            contentGeneratorEnabled: 'KI-Generator (Bausteine und Kurse)',
            qualityCheckEnabled: 'KI-Qualitätsprüfung',
            knowledgeBaseEnabled: 'Wissensbasis',
            helpBotEnabled: 'Hilfebot',
            recommendationsEnabled: 'KI-Kursempfehlungen',
            learningPathsEnabled: 'KI-Lernpfade',
            requireSignOffForAiCourses: 'Freigabe-Pflicht für KI-generierte Kurse',
        },
        switchHint: {
            contentGeneratorEnabled: 'Erzeugt Lektionsbausteine und komplette Kurs-Entwürfe aus Material.',
            qualityCheckEnabled: 'Bewertet Kurse in sieben Dimensionen mit Verbesserungsvorschlägen.',
            knowledgeBaseEnabled: 'Eigene Dokumente als Grundlage für Generator und Tutor (Tranche C).',
            helpBotEnabled: 'Bedienhilfe für Nutzer:innen (Tranche C).',
            recommendationsEnabled: 'Die KI wählt aus den regelbasierten Vorschlägen die passendsten Kurse aus und begründet sie den Lernenden gegenüber.',
            learningPathsEnabled: 'Lernende stellen sich mit der KI eigene Lernpfade zusammen; Kursersteller lassen sich Firmen-Lernpfade entwerfen.',
            requireSignOffForAiCourses: 'KI-generierte Kurse und Varianten können erst nach fachlicher Freigabe aktiviert werden.',
        },
        tutorPrompt: 'Zusatz-Anweisung für den KI-Tutor',
        tutorPromptHint: 'Optional: Tonfall, Ansprache, firmenspezifische Hinweise. Wird dem Tutor-Prompt vorangestellt.',
        limits: 'Tageslimits',
        limitsHint: 'Schutz des gemeinsamen KI-Backends. Höhere Limits stellt der Betreiber ein.',
        limitsHintOperator: 'Als Betreiber können Sie die Tageslimits dieses Unternehmens anpassen (0 schaltet die Funktion ab).',
        cap: { dailyCourseGenerationLimit: 'Kurs-Generierungen / Tag', dailyContentJobLimit: 'Baustein-Jobs / Tag', dailyVariantLimit: 'Varianten / Tag' },
        capDefault: 'Standard: %{value}',
        saved: 'KI-Einstellungen gespeichert.',
        saveError: 'Speichern fehlgeschlagen.',
        loadError: 'KI-Einstellungen konnten nicht geladen werden.',
    },
    blockPlayer: {
        unsupported: 'Dieser Inhaltstyp (%{type}) wird noch nicht unterstützt.',
        previewHint: 'Vorschau – Antworten werden nicht gewertet.',
        check: 'Prüfen',
        retry: 'Noch einmal',
        result: {
            correct: 'Richtig!',
            incorrect: 'Nicht ganz – %{percent} % richtig.',
            attempt: 'Versuch %{n}',
            error: 'Antwort konnte nicht gesendet werden.',
        },
        hotspot: { title: 'Hotspot-Übung', hint: 'Klicke die markierten Bereiche an, um sie zu erkunden.', progress: '%{done} von %{total} erkundet', area: 'Bereich %{n}' },
        labeling: { title: 'Beschriftungsübung', hint: 'Benenne die nummerierten Punkte im Bild.', answer: 'Beschriftung %{n}' },
        sorting: { title: 'Sortierübung', hint: 'Ziehe jedes Element in die passende Kategorie – oder tippe die Kategorienummer.', placeIn: 'In „%{category}“ einordnen', remove: 'Zurücklegen' },
        sliderScale: { title: 'Selbsteinschätzung', submit: 'Absenden', saved: 'Deine Einschätzung wurde gespeichert.' },
        discussion: { title: 'Diskussion', count: '%{smart_count} Beitrag |||| %{smart_count} Beiträge', empty: 'Noch keine Beiträge – schreib den ersten.', placeholder: 'Dein Beitrag …', send: 'Beitrag senden', reply: 'Antworten', replyingTo: 'Antwort auf einen Beitrag', delete: 'Beitrag löschen', approve: 'Freigeben', reject: 'Ablehnen', pending: 'Wartet auf Freigabe', rejected: 'Abgelehnt', anonymous: 'Teilnehmer:in', moderationHint: 'Beiträge werden vor der Veröffentlichung von Lehrenden geprüft.', error: 'Der Beitrag konnte nicht gespeichert werden.' },
        branching: { title: 'Verzweigung', step: 'Schritt %{n}', done: 'Pfad abgeschlossen (%{smart_count} Entscheidung) |||| Pfad abgeschlossen (%{smart_count} Entscheidungen)', restart: 'Von vorn beginnen' },
        simulation: { title: 'Situationsaufgabe', decision: 'Entscheidung %{n}', continue: 'Weiter', finish: 'Abschließen', done: 'Situationsaufgabe abgeschlossen.', restart: 'Von vorn beginnen' },
        scorm: { title: 'SCORM-Paket', empty: 'SCORM-Paket ist noch nicht konfiguriert.', completed: 'Abgeschlossen', fullscreen: 'Vollbild' },
        h5p: { title: 'H5P-Inhalt', empty: 'H5P-Inhalt ist noch nicht konfiguriert.' },
        quiz: { title: 'Quiz', multi: 'Mehrere Antworten' },
        fillBlank: { title: 'Lückentext', blank: 'Lücke %{n}' },
        matching: { title: 'Zuordnung', choose: 'Bitte wählen …', correctIs: 'Richtig: %{text}' },
        ordering: { title: 'Reihenfolge', hint: 'Bringe die Elemente mit den Pfeilen in die richtige Reihenfolge.' },
        flashcard: { title: 'Karteikarten', flip: 'Umdrehen', front: 'Vorderseite', back: 'Rückseite', prev: 'Zurück', next: 'Weiter' },
        poll: { title: 'Umfrage', vote: 'Abstimmen', change: 'Stimme ändern', voters: '%{smart_count} Stimme |||| %{smart_count} Stimmen', error: 'Stimme konnte nicht gespeichert werden.' },
        file: { download: 'Datei herunterladen' },
        pdf: { title: 'PDF-Dokument' },
        completion: {
            button: 'Lektion abschließen',
            progress: '%{done} von %{total} Übungen bearbeitet',
            score: 'Ergebnis %{score} %',
            missing: 'Bitte bearbeite zuerst die verbleibende Übung. |||| Bitte bearbeite zuerst die verbleibenden %{smart_count} Übungen.',
            belowMin: 'Du hast %{score} % erreicht, nötig sind %{min} %. Versuche die Übungen noch einmal.',
        },
    },
    lessons: {
        title: 'Lektionen',
        loading: 'Lade Lektionen...',
        loadError: 'Fehler beim Laden der Lektionen',
        loadCourseError: 'Fehler beim Laden des Kurses',
        newLesson: 'Neue Lektion',
        convert: {
            button: 'Als v2-Kopie anlegen',
            title: '„%{title}“ ins Block-Format übernehmen',
            intro: 'Es entsteht eine inaktive Kopie im Autorentool v2; der klassische Kurs bleibt unverändert. Die Tabelle zeigt vorab, welche Lektionen sauber übernommen werden und wo Nacharbeit nötig ist.',
            summary: '%{total} Lektionen: %{converted} konvertiert, %{partial} teilweise, %{manual} manuell nacharbeiten',
            lesson: 'Lektion',
            sourceType: 'Typ (klassisch)',
            blocks: 'Blöcke',
            status: 'Status',
            statusLabel: { converted: 'Konvertiert', partial: 'Teilweise', manual: 'Manuell' },
            create: 'Kopie anlegen',
            done: 'Kopie „%{title}“ angelegt – bitte im Builder prüfen und dann aktivieren.',
            error: 'Die Kopie konnte nicht angelegt werden.',
            previewError: 'Der Konvertierungsbericht konnte nicht geladen werden.',
        },
        editLesson: 'Lektion bearbeiten',
        createFirst: 'Erste Lektion erstellen',
        fromLibrary: 'Aus Bibliothek',
        noLessons: 'Noch keine Lektionen vorhanden',
        lessonsFor: 'Lektionen: %{title}',
        backToCourses: 'Zurück zu Kursen',
        editContent: 'Inhalt bearbeiten',
        preview: 'Vorschau',
        mandatory: 'Pflicht',
        minScore: 'Min. %{score}%',
        updateSuccess: 'Lektion erfolgreich aktualisiert',
        createSuccess: 'Lektion erfolgreich erstellt',
        deleteSuccess: 'Lektion erfolgreich gelöscht',
        saveError: 'Fehler beim Speichern der Lektion',
        deleteError: 'Fehler beim Löschen der Lektion',
        confirmDelete: 'Möchten Sie diese Lektion wirklich endgültig löschen?\n\nDie Fortschrittsdaten der Teilnehmer werden automatisch angepasst.',
        learningContent: {
            label: 'Lerninhalt (optional)',
            helper: 'Dieser formatierte Text wird im Player über dem Quiz angezeigt.',
        },
        types: {
            video: 'Video',
            document: 'Dokument',
            infoText: 'Informationstext',
            multipleChoice: 'Multiple Choice',
            fillInBlank: 'Lückentext',
            freeText: 'Freitext',
            dragDrop: 'Drag & Drop',
            matching: 'Zuordnung',
            sorting: 'Sortierung',
            hotspot: 'Hotspot',
            timeline: 'Zeitstrahl',
            scorm: 'SCORM',
            h5p: 'H5P',
            xapi: 'xAPI',
        },
        form: {
            title: 'Titel',
            type: 'Typ',
            description: 'Beschreibung',
            estimatedDuration: 'Geschätzte Dauer (Minuten)',
            minScore: 'Minimale Punktzahl (%)',
            minScoreHelp: 'Prozentsatz, der zum Bestehen erreicht werden muss',
            isMandatory: 'Pflichtlektion',
            active: 'Aktiv',
            enablePeerReview: 'Peer-Review aktivieren',
            peerReviewInfo: 'Wenn aktiviert, müssen Teilnehmer ihre Antwort einreichen und erhalten Feedback von anderen Kursteilnehmern.',
            minPeerReviews: 'Mindestanzahl Reviews',
            minPeerReviewsHelp: 'Anzahl der Reviews, die jede Einreichung erhalten muss (1-10)',
            peerReviewCriteria: 'Bewertungskriterien',
            criterionName: 'Kriterium',
            criterionDescription: 'Beschreibung',
            maxPoints: 'Max. Punkte',
            addCriterion: 'Kriterium hinzufügen',
            aiTutor: 'KI-Lernassistent',
            aiTutorInherit: 'Vom Kurs übernehmen',
            aiTutorEnabled: 'Aktiviert',
            aiTutorDisabled: 'Deaktiviert',
        },
        peerReview: 'Peer-Review',
    },
    courseRating: {
        title: 'Kurs bewerten',
        editTitle: 'Bewertung bearbeiten',
        rateButton: 'Bewerten',
        editButton: 'Bewertung ändern',
        yourRating: 'Ihre Bewertung',
        comment: 'Kommentar (optional)',
        commentPlaceholder: 'Was hat Ihnen an diesem Kurs gefallen oder was könnte verbessert werden?',
        submitSuccess: 'Bewertung erfolgreich gespeichert',
        updateSuccess: 'Bewertung erfolgreich aktualisiert',
        deleteSuccess: 'Bewertung erfolgreich gelöscht',
        noRatings: 'Noch keine Bewertungen',
        ratings: '%{count} Bewertungen',
        averageRating: 'Durchschnitt',
        labels: {
            terrible: 'Schlecht',
            poor: 'Mäßig',
            ok: 'In Ordnung',
            good: 'Gut',
            excellent: 'Ausgezeichnet',
        },
        errors: {
            ratingRequired: 'Bitte wählen Sie eine Bewertung aus',
            saveFailed: 'Fehler beim Speichern der Bewertung',
            deleteFailed: 'Fehler beim Löschen der Bewertung',
        },
    },
    prerequisites: {
        title: 'Voraussetzungen',
        noPrerequisites: 'Keine Voraussetzungen',
        completed: 'Abgeschlossen',
        required: 'Erforderlich',
        recommended: 'Empfohlen',
        hard: 'Pflicht',
        soft: 'Empfohlen',
        clickToView: 'Klicken zum Anzeigen',
        status: {
            noRequired: 'Keine Voraussetzungen',
            allMet: 'Alle erfüllt',
            allMetTooltip: 'Sie haben alle Voraussetzungen erfüllt',
            blocked: '%{count} Pflicht nicht erfüllt',
            blockedTooltip: 'Sie müssen zuerst folgende Kurse abschließen: %{courses}',
            recommended: '%{count} empfohlen',
            warningTooltip: 'Folgende Kurse werden empfohlen: %{courses}',
        },
        warningDialog: {
            title: 'Empfohlene Voraussetzungen',
            message: 'Für den Kurs "%{course}" werden folgende Kurse empfohlen, die Sie noch nicht abgeschlossen haben.',
            recommendedCourses: 'Empfohlene Kurse:',
            proceedAnyway: 'Sie können trotzdem fortfahren, aber wir empfehlen, zuerst die folgenden Kurse abzuschließen.',
            goBack: 'Zurück',
            proceedButton: 'Trotzdem einschreiben',
        },
        blockDialog: {
            title: 'Voraussetzungen nicht erfüllt',
            message: 'Sie können sich nicht für den Kurs "%{course}" einschreiben, da Sie die erforderlichen Voraussetzungen noch nicht erfüllt haben.',
            requiredCourses: 'Erforderliche Kurse:',
            completeFirst: 'Bitte schließen Sie diese Kurse zuerst ab, um sich einschreiben zu können.',
        },
    },
    gamification: {
        achievements: 'Meine Erfolge',
        badgesTitle: 'Auszeichnungen',
        streakTitle: 'Lernserie',
        leaderboardTitle: 'Rangliste',
        fullLeaderboard: 'Vollständige Rangliste',
        earned: 'Verdient',
        available: 'Verfügbar',
        noBadgesYet: 'Sie haben noch keine Auszeichnungen verdient. Schließen Sie Kurse ab, um Auszeichnungen zu erhalten!',
        allBadgesEarned: 'Herzlichen Glückwunsch! Sie haben alle verfügbaren Auszeichnungen verdient.',
        days: 'Tage',
        currentStreak: 'Aktuelle Serie',
        longestStreak: 'Längste Serie',
        rank: 'Rang',
        streakAtRisk: 'Ihre Serie ist in Gefahr! Lernen Sie heute noch etwas.',
        streakAtRiskMessage: 'Lernen Sie heute, um Ihre Serie zu erhalten!',
        streakTooltip: '%{days} Tage Lernserie',
        badgeEarned: 'Auszeichnung verdient!',
        awesome: 'Super!',
        congratulations: 'Herzlichen Glückwunsch!',
        leaderboard: {
            rank: 'Rang',
            user: 'Benutzer',
            courses: 'Kurse',
            badges: 'Auszeichnungen',
            streakDays: 'Serien-Tage',
            byCourses: 'Nach Kursen',
            byBadges: 'Nach Auszeichnungen',
            byStreak: 'Nach Serie',
            you: 'Sie',
            yourPosition: 'Ihre Position',
        },
    },
    learningPaths: {
        title: 'Lernpfade',
        myPaths: 'Meine Lernpfade',
        explore: 'Lernpfade entdecken',
        courses: 'Kurse',
        search: 'Lernpfad suchen...',
        difficulty: 'Schwierigkeit',
        allDifficulties: 'Alle',
        beginner: 'Einstieg',
        intermediate: 'Vertiefung',
        advanced: 'Spezialisierung',
        noPathsFound: 'Keine Lernpfade gefunden',
        noEnrollments: 'Keine aktiven Lernpfade',
        exploreDescription: 'Entdecke Lernpfade und starte deine Lernreise',
        progress: 'Fortschritt',
        yourProgress: 'Dein Fortschritt',
        enroll: 'Einschreiben',
        enrollNow: 'Jetzt einschreiben',
        enrollSuccess: 'Erfolgreich eingeschrieben!',
        continue: 'Fortsetzen',
        viewCertificate: 'Ansehen',
        start: 'Starten',
        completed: 'Abgeschlossen',
        completedOn: 'Abgeschlossen am',
        courseList: 'Kursübersicht',
        required: 'Pflicht',
        optional: 'Optional',
        status: {
            enrolled: 'Eingeschrieben',
            inProgress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
        },
        personal: 'Persönlich',
        pathCertificateHint: 'Für diesen Lernpfad gibt es ein gemeinsames Zertifikat nach Abschluss aller Kurse – die einzelnen Kurse stellen keines aus.',
        ai: {
            button: 'Lernpfad mit KI erstellen',
            pageHint: 'Du sagst der KI, was du lernen willst – sie stellt dir eine passende Kursfolge zusammen.',
            title: 'Lernpfad mit KI erstellen',
            intro: 'Beschreibe, was du lernen willst. Die KI wählt passende Kurse aus dem Katalog und bringt sie in eine sinnvolle Reihenfolge – du kannst den Vorschlag danach anpassen.',
            topic: 'Thema',
            goal: 'Ziel (optional)',
            level: 'Dein aktuelles Niveau',
            preview: 'Vorschlag erstellen',
            previewError: 'Der Vorschlag konnte nicht erstellt werden.',
            reviewHint: 'Titel anpassen, Kurse entfernen – dann anlegen.',
            pathTitle: 'Titel des Lernpfads',
            removeStep: '%{title} entfernen',
            estimate: '%{steps} Kurse, ca. %{hours} Stunden',
            companyPath: 'Als Firmen-Lernpfad anlegen (inaktiv, zur Prüfung in der Verwaltung)',
            pathCertificate: 'Ein Zertifikat für den ganzen Lernpfad statt je Kurs',
            back: 'Zurück',
            create: 'Lernpfad anlegen',
            created: 'Lernpfad „%{title}“ angelegt.',
            createError: 'Der Lernpfad konnte nicht angelegt werden.',
        },
    },
    common: {
        back: 'Zurück',
        viewAll: 'Alle anzeigen',
        cancel: 'Abbrechen',
        save: 'Speichern',
        saving: 'Speichern...',
        delete: 'Löschen',
    },
    recommendations: {
        title: 'Empfohlen für Sie',
        aiBadge: 'KI',
        aiHint: 'Von der KI für dich ausgewählt – mit Begründung.',
        aiPending: 'Die KI stellt gerade persönliche Empfehlungen zusammen …',
        similarCourses: 'Ähnliche Kurse',
        enroll: 'Einschreiben',
        noRecommendations: 'Keine Empfehlungen verfügbar',
        reasons: {
            sameCatalog: 'Aus Ihrem bevorzugten Katalog',
            nextDifficulty: 'Nächster Schwierigkeitsgrad',
            sameDifficulty: 'Passender Schwierigkeitsgrad',
            matchingTags: 'Ähnliche Themen',
            prerequisitesMet: 'Voraussetzungen erfüllt',
            popular: 'Bei anderen Lernenden beliebt',
            beginnerFriendly: 'Ideal für Einsteiger',
        },
    },
    notifications: {
        title: 'Benachrichtigungen',
        noNotifications: 'Keine Benachrichtigungen',
        markAllRead: 'Alle gelesen',
        justNow: 'Gerade eben',
        minutesAgo: 'Vor %{count} Min.',
        hoursAgo: 'Vor %{count} Std.',
        daysAgo: 'Vor %{count} Tagen',
        types: {
            course_completed: 'Kurs abgeschlossen',
            certificate_earned: 'Zertifikat erhalten',
            badge_earned: 'Auszeichnung verdient',
            learning_path_completed: 'Lernpfad abgeschlossen',
            streak_milestone: 'Serien-Meilenstein',
            system: 'Systemnachricht',
        },
    },
    emptyStates: {
        noCourses: {
            title: 'Keine Kurse gefunden',
            description: 'Es sind noch keine Kurse verfügbar. Schauen Sie später wieder vorbei!',
            action: 'Kurskataloge durchsuchen',
        },
        noBadges: {
            title: 'Noch keine Auszeichnungen',
            description: 'Schließen Sie Kurse ab und erreichen Sie Meilensteine, um Auszeichnungen zu verdienen!',
        },
        noLearningPaths: {
            title: 'Keine Lernpfade',
            description: 'Sie haben sich noch für keinen Lernpfad eingeschrieben.',
            action: 'Lernpfade entdecken',
        },
        noRecommendations: {
            title: 'Keine Empfehlungen',
            description: 'Schließen Sie mehr Kurse ab, um personalisierte Empfehlungen zu erhalten.',
        },
        noEnrollments: {
            title: 'Noch keine Kurse',
            description: 'Sie haben sich noch für keinen Kurs eingeschrieben. Entdecken Sie unseren Kurskatalog!',
            action: 'Kurse entdecken',
        },
        noSearchResults: {
            title: 'Keine Ergebnisse',
            description: 'Versuchen Sie andere Suchbegriffe.',
            descriptionWithTerm: 'Keine Ergebnisse für "%{term}" gefunden. Versuchen Sie andere Suchbegriffe.',
        },
    },
    bookmarks: {
        title: 'Meine Lesezeichen',
        add: 'Lesezeichen hinzufügen',
        remove: 'Lesezeichen entfernen',
        noBookmarks: 'Keine Lesezeichen vorhanden. Speichern Sie interessante Kurse für später!',
        errorLoading: 'Fehler beim Laden der Lesezeichen',
        savedOn: 'Gespeichert am',
        editNote: 'Notiz bearbeiten',
        noteLabel: 'Notiz',
        notePlaceholder: 'Warum möchten Sie diesen Kurs speichern?',
    },
    progress: {
        weeklyTitle: 'Diese Woche',
        errorLoading: 'Fehler beim Laden des Fortschritts',
        lessonsCompleted: 'Lektionen',
        coursesCompleted: 'Kurse',
        activeDays: 'Aktive Tage',
        dailyActivity: 'Tägliche Aktivität',
        lessons: 'Lektionen',
        overallProgress: 'Gesamtfortschritt',
        coursesLabel: 'Kurse',
        inProgress: 'In Bearbeitung',
        complete: 'abgeschlossen',
        days: {
            mon: 'Mo',
            tue: 'Di',
            wed: 'Mi',
            thu: 'Do',
            fri: 'Fr',
            sat: 'Sa',
            sun: 'So',
        },
    },
    notes: {
        notes: 'Notizen',
        add: 'Hinzufügen',
        addNote: 'Notiz hinzufügen',
        newNote: 'Neue Notiz',
        editNote: 'Notiz bearbeiten',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        title: 'Titel',
        titlePlaceholder: 'Optionaler Titel...',
        content: 'Inhalt',
        contentPlaceholder: 'Schreiben Sie Ihre Notiz hier...',
        color: 'Farbe',
        privateNote: 'Private Notiz',
        private: 'Privat',
        public: 'Öffentlich',
        untitled: 'Ohne Titel',
        noNotes: 'Noch keine Notizen vorhanden',
        noLessonNotes: 'Keine Notizen für diese Lektion',
        createFirst: 'Erste Notiz erstellen',
        createFirstNote: 'Erstellen Sie Ihre erste Notiz in einem Kurs',
        currentLesson: 'Aktuelle Lektion',
        otherCourseNotes: 'Notizen aus anderen Lektionen',
        errorLoading: 'Fehler beim Laden der Notizen',
        loadError: 'Fehler beim Laden der Notizen',
        deleteConfirmTitle: 'Notiz löschen?',
        deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Notiz löschen möchten?',
        // Overview page
        myNotes: 'Meine Notizen',
        overviewDescription: 'Alle Ihre Notizen aus allen Kursen an einem Ort.',
        search: 'Notizen durchsuchen...',
        sort: 'Sortieren',
        filter: 'Filtern',
        sortByDate: 'Nach Datum',
        sortByTitle: 'Nach Titel',
        sortByCourse: 'Nach Kurs',
        filterAll: 'Alle Notizen',
        filterWithLesson: 'Mit Lektion verknüpft',
        filterCourseOnly: 'Nur Kurs-Notizen',
        totalNotes: '%{count} Notizen',
        totalCourses: '%{count} Kurse',
        notesCount: '%{count} Notizen',
        notesLabel: 'Notizen',
        coursesLabel: 'Kurse',
        noSearchResults: 'Keine Notizen gefunden',
        tryDifferentSearch: 'Versuchen Sie einen anderen Suchbegriff',
        goToCourse: 'Zum Kurs',
        courseUnavailable: 'Kurs nicht mehr verfügbar',
        exportPdf: 'Als PDF herunterladen',
        exportPdfShort: 'PDF',
    },
    search: {
        title: 'Suche',
        placeholder: 'Kurse, Aktuelles & Wissen, Lernpfade durchsuchen...',
        resultsFor: 'Ergebnisse für "%{query}"',
        results: 'Ergebnisse',
        noResults: 'Keine Ergebnisse gefunden',
        tryDifferentTerms: 'Versuchen Sie andere Suchbegriffe',
        enterQuery: 'Geben Sie einen Suchbegriff ein',
        errorSearch: 'Fehler bei der Suche',
        filters: 'Filter',
        contentType: 'Inhaltstyp',
        difficultyLabel: 'Schwierigkeit',
        allDifficulties: 'Alle Schwierigkeiten',
        fromCourse: 'Aus Kurs',
        types: {
            course: 'Kurs',
            lesson: 'Lektion',
            wiki: 'Aktuelles & Wissen',
            learningPath: 'Lernpfad',
            learningGroup: 'Lerngruppe',
        },
        difficulty: {
            beginner: 'Einstieg',
            intermediate: 'Vertiefung',
            advanced: 'Spezialisierung',
        },
    },
    export: {
        button: 'Export',
        dialog: {
            title: 'Daten exportieren',
        },
        forCourse: 'Für Kurs',
        general: 'Allgemeine Exporte',
        success: 'Export erfolgreich heruntergeladen!',
        'learning-history': {
            label: 'Lernhistorie',
            description: 'Komplette Übersicht aller Kurse und Fortschritte',
        },
        transcript: {
            label: 'Kurs-Transkript',
            description: 'Detaillierter Bericht über diesen Kurs',
        },
        notes: {
            label: 'Notizen',
            description: 'Ihre persönlichen Notizen als PDF',
        },
        'progress-report': {
            label: 'Fortschrittsbericht',
            description: 'CSV-Export mit detaillierten Fortschrittsdaten',
        },
    },
    analytics: {
        title: 'Meine Lernstatistiken',
        errorLoading: 'Fehler beim Laden der Analytics',
        totalCourses: 'Kurse gesamt',
        completedCourses: 'Abgeschlossen',
        inProgress: 'in Bearbeitung',
        learningTime: 'Lernzeit',
        achievements: 'Erfolge',
        completionRate: 'Abschlussrate',
        lessonsCompleted: 'Abgeschlossene Lektionen',
        learningTimePerDay: 'Lernzeit pro Tag',
        recentCompletions: 'Letzte Abschlüsse',
        noCompletions: 'Noch keine Abschlüsse',
        progressSummary: 'Fortschrittsübersicht',
        avgProgress: 'Durchschnittlicher Fortschritt',
        avgScore: 'Durchschnittliche Punktzahl',
        myCourses: 'Meine Kurse',
        noCourses: 'Keine Kurse vorhanden',
        enrolled: 'Eingeschrieben',
        time: 'Zeit',
        activityOverview: 'Aktivitätsübersicht',
        enrollmentTrend: 'Einschreibungen',
        completionTrend: 'Kursabschlüsse',
        inLast: 'In den letzten',
        days: 'Tagen',
        noCourseData: 'Keine Kursdaten vorhanden',
        course: 'Kurs',
        participants: 'Teilnehmer',
        period: {
            week: '7 Tage',
            month: '30 Tage',
            quarter: '90 Tage',
        },
        tabs: {
            overview: 'Übersicht',
            courses: 'Kurse',
            activity: 'Aktivität',
        },
        status: {
            completed: 'Abgeschlossen',
            inProgress: 'In Bearbeitung',
            enrolled: 'Eingeschrieben',
        },
        instructor: {
            title: 'Trainer-Dashboard',
            subtitle: 'Übersicht über die Performance Ihrer Kurse',
            errorLoading: 'Fehler beim Laden der Trainer-Statistiken',
            noCourses: 'Sie haben noch keine Kurse erstellt',
            createCourse: 'Erstellen Sie einen Kurs, um Statistiken zu sehen',
            myCourses: 'Meine Kurse',
            participants: 'Teilnehmer',
            enrollments: 'Einschreibungen',
            completions: 'Abschlüsse',
            completionRate: 'Abschlussrate',
            avgProgress: 'Ø Fortschritt',
            avgProgressShort: 'Ø Fortschritt',
            avgScore: 'Ø Punkte',
            courseOverview: 'Kursübersicht',
            course: 'Kurs',
            enrolled: 'Eingeschrieben',
            completed: 'Abgeschlossen',
            lessonDetails: 'Lektionsdetails',
            selectCourse: 'Wählen Sie einen Kurs aus der Tabelle',
            courseStatsError: 'Die Kursstatistik konnte nicht geladen werden',
            lesson: 'Lektion',
            attempts: 'Versuche',
            lessonCompletions: 'Abschlüsse',
            avgTime: 'Ø Zeit',
        },
    },
    privacy: {
        title: 'Datenschutz',
        subtitle: 'Lade eine vollständige Kopie deiner Daten herunter (Art. 15/20 DSGVO) oder lösche dein Konto (Art. 17 DSGVO).',
        exportButton: 'Meine Daten herunterladen (PDF)',
        exportButtonJson: 'Als JSON für andere Anbieter',
        exportSuccess: 'Dein Datenexport wurde heruntergeladen.',
        exportError: 'Export fehlgeschlagen. Bitte versuche es erneut.',
        deleteButton: 'Konto löschen',
        deleteTitle: 'Löschung deines Kontos beantragen?',
        deleteWarning: 'Dein Unternehmens-Administrator erhält deinen Antrag und entscheidet innerhalb eines Monats. Nach der Genehmigung wird dein Konto anonymisiert und nach der Aufbewahrungsfrist endgültig gelöscht. Entscheidet bis dahin niemand, wird es automatisch gelöscht. Bis zur Entscheidung kannst du dich weiter anmelden und den Antrag zurückziehen.',
        deleteConfirmButton: 'Löschung beantragen',
        deleteConfirmLabel: 'Zur Bestätigung "LÖSCHEN" eingeben',
        deleteConfirmWord: 'LÖSCHEN',
        deleteSuccess: 'Dein Löschantrag ist eingegangen. Dein Unternehmens-Administrator entscheidet bis zum %{dueAt}.',
        pendingTitle: 'Löschantrag gestellt',
        pendingText: 'Du hast am %{requestedAt} beantragt, dein Konto zu löschen. Dein Unternehmens-Administrator entscheidet bis zum %{dueAt}.',
        withdrawButton: 'Antrag zurückziehen',
        withdrawSuccess: 'Dein Löschantrag wurde zurückgezogen.',
        cancel: 'Abbrechen',
    },
    aiGrading: {
        disclaimer: 'Deine Antwort wird durch ein KI-System vorbewertet. Bitte gib keine sensiblen persönlichen Informationen ein. Du hast jederzeit das Recht auf eine Überprüfung durch deine Trainer:in.',
        attribution: 'KI-assistierte Bewertung — bei Beanstandung wende dich an deine Trainer:in.',
        model: 'Modell',
        reviewPending: 'Diese Bewertung wird von einer berechtigten Person geprüft und zählt erst nach der Freigabe.',
        reviewPendingLesson: 'Deine Antworten wurden eingereicht. Die KI-Vorbewertung wird von einer berechtigten Person geprüft — die Lektion wird nach der Freigabe automatisch abgeschlossen.',
    },
    aiReview: {
        title: 'KI-Bewertungen prüfen',
        subtitle: 'KI-vorbewertete Freitext-Antworten deiner Lernenden. Bei Kursen mit Pflicht-Review zählt die Bewertung erst nach deiner Freigabe zum Abschluss.',
        status: 'Status',
        all: 'Alle',
        minScore: 'Score ab',
        maxScore: 'Score bis',
        course: 'Kurs / Lektion',
        answer: 'Antwort',
        score: 'KI-Score',
        statusCol: 'Status',
        date: 'Eingereicht',
        actions: 'Aktionen',
        approve: 'Freigeben',
        override: 'Übersteuern',
        overrideTitle: 'Bewertung übersteuern',
        overrideHint: 'KI-Vorschlag',
        newScore: 'Neuer Score',
        newFeedback: 'Feedback an die lernende Person',
        originalAi: 'KI ursprünglich',
        cancel: 'Abbrechen',
        save: 'Speichern',
        approved: 'Bewertung freigegeben.',
        approvedCompleted: 'Freigegeben — Lektion wurde abgeschlossen.',
        overridden: 'Bewertung übersteuert.',
        empty: 'Keine KI-Bewertungen für die aktuelle Filterung.',
    },
    tutor: {
        title: 'KI-Lernassistent',
        aiLabel: 'KI',
        disclaimerTitle: 'Du chattest mit einer KI',
        disclaimerBody: 'Der Lernassistent ist ein KI-System. Antworten können ungenau oder unvollständig sein — verlasse dich bei wichtigen Fragen nicht allein darauf und frage im Zweifel deine Trainer:in. Deine Konversationen sind privat, werden auf unseren eigenen Servern verarbeitet und du kannst sie jederzeit löschen. Bitte gib keine sensiblen persönlichen Informationen ein.',
        disclaimerAccept: 'Verstanden',
        newConversation: 'Neues Gespräch',
        history: 'Verlauf',
        noConversations: 'Keine früheren Gespräche',
        welcomeTitle: 'Hallo! Ich bin dein Lernassistent.',
        welcomeWithLesson: 'Stelle mir Fragen zur Lektion "%{lesson}"',
        welcomeGeneral: 'Stelle mir eine Frage zum Kursinhalt.',
        inputPlaceholder: 'Stelle eine Frage...',
        inputWithLesson: 'Frage zu "%{lesson}"...',
        quickHelpLabel: 'Schnelle Hilfe',
        quickHelp: {
            explain: 'Einfacher',
            explainTooltip: 'Erkläre diesen Inhalt einfacher',
            example: 'Beispiel',
            exampleTooltip: 'Zeige mir ein Beispiel',
            quiz: 'Teste mich',
            quizTooltip: 'Stelle mir eine Frage zum Testen',
            summary: 'Zusammenfassung',
            summaryTooltip: 'Fasse den Inhalt zusammen',
        },
        error: 'Fehler bei der Anfrage',
        loadError: 'Fehler beim Laden',
    },
    learningGroups: {
        title: 'Lerngruppen',
        myGroups: 'Meine Lerngruppen',
        explore: 'Lerngruppen entdecken',
        createGroup: 'Lerngruppe erstellen',
        noGroups: 'Keine Lerngruppen gefunden',
        noMyGroups: 'Sie sind noch keiner Lerngruppe beigetreten',
        loading: 'Lade Lerngruppen...',
        members: '%{count} Mitglieder',
        maxMembers: 'Max. %{count} Mitglieder',
        course: 'Kurs',
        public: 'Öffentlich',
        private: 'Nur auf Einladung',
        join: 'Beitreten',
        leave: 'Austreten',
        viewGroup: 'Gruppe ansehen',
        createdBy: 'Erstellt von %{name}',
        joinSuccess: 'Erfolgreich beigetreten!',
        leaveSuccess: 'Gruppe verlassen',
        errorJoining: 'Fehler beim Beitreten',
        errorLeaving: 'Fehler beim Verlassen',
        createDialog: {
            title: 'Neue Lerngruppe erstellen',
            name: 'Gruppenname',
            namePlaceholder: 'z.B. JavaScript Einsteiger',
            description: 'Beschreibung',
            descriptionPlaceholder: 'Beschreibe worum es in der Gruppe geht...',
            course: 'Kurs (optional)',
            selectCourse: 'Kurs auswählen',
            noCourse: 'Kein Kurs',
            maxMembers: 'Max. Mitglieder',
            maxMembersHelp: 'Leer lassen für unbegrenzt',
            isPublic: 'Öffentliche Gruppe',
            isPublicHelp: 'Öffentliche Gruppen können von jedem beigetreten werden',
        },
        detail: {
            members: 'Mitglieder',
            chat: 'Gruppenchat',
            admin: 'Admin',
            member: 'Mitglied',
            noMessages: 'Noch keine Nachrichten. Starte die Konversation!',
            typePlaceholder: 'Nachricht schreiben...',
            send: 'Senden',
            you: 'Du',
            errorLoading: 'Fehler beim Laden der Gruppe',
            errorSending: 'Fehler beim Senden',
        },
        tabs: {
            myGroups: 'Meine Lerngruppen',
            explore: 'Erkunden',
        },
    },
    peerReview: {
        title: 'Peer-Reviews',
        tabs: {
            toReview: 'Zu bewerten',
            mySubmissions: 'Meine Abgaben (%{count})',
        },
        noPendingReviews: 'Keine ausstehenden Reviews',
        noSubmissions: 'Keine Abgaben vorhanden',
        status: {
            pending: 'Ausstehend',
            inReview: 'In Bearbeitung',
            completed: 'Abgeschlossen',
        },
        assignedOn: 'Zugewiesen am %{date}',
        submittedOn: 'Eingereicht am %{date}',
        reviewsReceived: '%{count} Reviews',
        review: 'Bewerten',
        viewFeedback: 'Feedback ansehen',
        notFound: 'Auftrag nicht gefunden',
        submitTitle: 'Abgabe zur Peer-Review einreichen',
        submitDescription: 'Reichen Sie Ihre Arbeit zur Lektion "%{lesson}" ein. Andere Teilnehmer werden Ihre Abgabe bewerten.',
        submissionLabel: 'Ihre Abgabe',
        submissionPlaceholder: 'Beschreiben Sie Ihre Lösung oder fügen Sie Ihren Text hier ein...',
        submit: 'Einreichen',
        submitSuccess: 'Ihre Abgabe wurde erfolgreich eingereicht und wird von anderen Teilnehmern bewertet.',
        reviewTitle: 'Peer-Review: %{lesson}',
        submissionToReview: 'Zu bewertende Abgabe',
        criteria: 'Bewertungskriterien',
        yourReview: 'Ihre Bewertung',
        ratingLabel: 'Gesamtbewertung',
        feedbackLabel: 'Ihr Feedback',
        feedbackPlaceholder: 'Geben Sie konstruktives Feedback zur Abgabe. Was war gut? Was könnte verbessert werden?',
        submitReview: 'Bewertung absenden',
        resultTitle: 'Feedback für: %{lesson}',
        yourSubmission: 'Ihre Abgabe',
        averageRating: 'Durchschnittliche Bewertung',
        reviewCount: '%{count} Reviews',
        receivedFeedback: 'Erhaltenes Feedback',
        noFeedbackYet: 'Noch kein Feedback erhalten. Ihre Abgabe wird noch bearbeitet.',
        reviewer: 'Reviewer %{number}',
        reviewedOn: 'Bewertet am %{date}',
        attachFile: 'Datei anhängen',
        fileHint: 'Optional: PDF, Word, Text, Bilder oder ZIP (max. 10MB)',
        downloadAttachment: 'Anhang herunterladen',
        errors: {
            submissionRequired: 'Bitte geben Sie Ihre Abgabe ein',
            ratingRequired: 'Bitte geben Sie eine Bewertung ab',
            feedbackRequired: 'Bitte geben Sie Feedback ein',
            fileTooLarge: 'Datei zu groß (max. 10MB)',
        },
    },
    faq: {
        title: 'Hilfe & FAQ',
        subtitle: 'Finden Sie Antworten auf häufig gestellte Fragen',
        searchPlaceholder: 'FAQ durchsuchen...',
        allCategories: 'Alle',
        noResults: 'Keine FAQ-Einträge zu Ihrer Suche gefunden.',
        noArticles: 'Noch keine FAQ-Einträge vorhanden.',
        loadError: 'Fehler beim Laden der FAQ',
        contentError: 'Inhalt konnte nicht geladen werden.',
        noContent: 'Kein Inhalt verfügbar.',
        contactSupport: 'Ihre Frage nicht gefunden? Kontaktieren Sie unseren Support.',
    },
    products: {
        title: 'Produkte',
        searchPlaceholder: 'Produkte suchen...',
        filterType: 'Typ',
        filterVisibility: 'Sichtbarkeit',
        allTypes: 'Alle Typen',
        allVisibility: 'Alle',
        loadError: 'Fehler beim Laden der Produkte',
        noProducts: 'Keine Produkte verfügbar.',
        noSearchResults: 'Keine Produkte für Ihre Suche gefunden.',
        featured: 'Empfohlen',
        inactive: 'Inaktiv',
        noPrice: 'Kein Preis festgelegt',
        types: {
            course: 'Kurs',
            catalog: 'Katalog',
            bundle: 'Paket',
            libraryItem: 'Bibliothekseintrag',
        },
        visibility: {
            public: 'Öffentlich',
            private: 'Privat',
            unlisted: 'Nicht gelistet',
        },
        pricing: {
            free: 'Kostenlos',
            oneTime: 'Einmalzahlung',
            subscription: 'Abonnement',
            perMonth: 'pro Monat',
            perYear: 'pro Jahr',
        },
        actions: {
            view: 'Ansehen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            addToCart: 'In den Warenkorb',
            enroll: 'Jetzt anmelden',
        },
    },
    library: {
        title: 'Inhaltsbibliothek',
        tabs: {
            myLibrary: 'Meine Bibliothek',
            operatorLibrary: 'Plattform-Bibliothek',
            company: 'Meine Bibliothek',
            operator: 'Plattform-Bibliothek',
        },
        search: 'Bibliothek durchsuchen...',
        selectDialog: {
            titleCourse: 'Kurs aus Bibliothek einfügen',
            titleLesson: 'Lektion aus Bibliothek einfügen',
        },
        types: {
            course: 'Kurs',
            lesson: 'Lektion',
        },
        access: {
            copyAllowed: 'Kopie erlaubt',
            referenceOnly: 'Nur Referenz',
        },
        operatorContent: 'Plattform-Inhalt',
        usageCount: '%{count}x verwendet',
        version: 'Version %{version}',
        searchPlaceholder: 'Bibliothek durchsuchen...',
        filterType: 'Typ',
        allTypes: 'Alle Typen',
        refresh: 'Aktualisieren',
        loadError: 'Fehler beim Laden der Bibliothek',
        noSearchResults: 'Keine Ergebnisse für Ihre Suche gefunden.',
        noItems: 'Noch keine Einträge in der Bibliothek.',
        insertSuccess: '"%{title}" erfolgreich eingefügt',
        insertError: 'Fehler beim Einfügen aus der Bibliothek',
        confirmDelete: 'Möchten Sie "%{title}" wirklich aus der Bibliothek löschen?',
        deleteSuccess: 'Erfolgreich aus der Bibliothek gelöscht',
        deleteError: 'Fehler beim Löschen',
        actions: {
            insert: 'Einfügen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            share: 'Freigeben',
        },
        saveDialog: {
            title: 'In Bibliothek speichern',
            titleLabel: 'Titel',
            descriptionLabel: 'Beschreibung',
            tagsLabel: 'Schlagworte',
            tagsPlaceholder: 'Schlagwort eingeben...',
            tagsHelp: 'Drücken Sie Enter, um ein Schlagwort hinzuzufügen',
            operatorContent: 'Als Plattform-Inhalt speichern',
            operatorContentHint: 'Plattform-Inhalte können für Mandanten freigegeben werden und sind nur für Operatoren sichtbar.',
            save: 'In Bibliothek speichern',
            titleRequired: 'Titel ist erforderlich',
            success: 'Erfolgreich in der Bibliothek gespeichert',
            error: 'Fehler beim Speichern in der Bibliothek',
        },
        insertDialog: {
            title: 'Aus Bibliothek einfügen',
            description: 'Wählen Sie, wie der Inhalt eingefügt werden soll:',
            copyNotAllowed: 'Für diesen Inhalt ist nur der Referenz-Modus verfügbar.',
            copyOption: 'Kopie erstellen',
            copyDescription: 'Erstellt eine unabhängige Kopie, die Sie frei bearbeiten können.',
            referenceOption: 'Referenz erstellen',
            referenceDescription: 'Bleibt mit dem Original verknüpft. Sie erhalten Benachrichtigungen bei Updates.',
            confirm: 'Einfügen',
            courseCreated: 'Kurs "%{title}" erfolgreich %{mode}',
            lessonCreated: 'Lektion "%{title}" erfolgreich %{mode}',
            asCopy: 'als Kopie erstellt',
            asReference: 'als Referenz erstellt',
        },
        sharing: {
            title: 'Inhalt freigeben',
            description: 'Wählen Sie die Mandanten aus, für die dieser Inhalt freigegeben werden soll.',
            noCompanies: 'Keine Mandanten verfügbar.',
            loadError: 'Fehler beim Laden der Mandanten.',
            saveSuccess: 'Freigaben erfolgreich gespeichert.',
            saveError: 'Fehler beim Speichern der Freigaben.',
            revokeSuccess: 'Freigabe erfolgreich entzogen.',
            revokeError: 'Fehler beim Entziehen der Freigabe.',
            revoke: 'Freigabe entziehen',
            accessType: 'Zugriffstyp',
            readonly: 'Nur Referenz (schreibgeschützt)',
            copyAllowed: 'Kopie erlaubt',
            expiresAt: 'Ablaufdatum',
            expiresAtHelp: 'Leer lassen für unbegrenzten Zugang',
        },
        updates: {
            title: 'Verfügbare Updates',
            description: '%{count} Inhalt(e) haben Updates von der Bibliothek verfügbar.',
            checking: 'Prüfe auf Updates...',
            apply: 'Update anwenden',
            applySuccess: 'Update erfolgreich angewendet.',
            applyError: 'Fehler beim Anwenden des Updates.',
            versionChange: 'Version %{from} → %{to}',
            noUpdates: 'Alle Inhalte sind aktuell.',
        },
    },
    cart: {
        title: 'Warenkorb',
        empty: {
            title: 'Ihr Warenkorb ist leer',
            description: 'Entdecken Sie unsere Produkte und fügen Sie sie zu Ihrem Warenkorb hinzu.',
        },
        unknownProduct: 'Unbekanntes Produkt',
        subtotal: 'Zwischensumme',
        discount: 'Rabatt',
        tax: 'MwSt.',
        total: 'Gesamtsumme',
        actions: {
            checkout: 'Zur Kasse',
            continueShopping: 'Weiter einkaufen',
            clear: 'Leeren',
            remove: 'Entfernen',
        },
        messages: {
            itemAdded: 'Produkt zum Warenkorb hinzugefügt',
            itemRemoved: 'Produkt aus dem Warenkorb entfernt',
            cartCleared: 'Warenkorb geleert',
            addError: 'Fehler beim Hinzufügen zum Warenkorb',
            removeError: 'Fehler beim Entfernen aus dem Warenkorb',
            updateError: 'Fehler beim Aktualisieren des Warenkorbs',
            clearError: 'Fehler beim Leeren des Warenkorbs',
        },
    },
    orders: {
        title: 'Meine Bestellungen',
        loading: 'Bestellungen werden geladen...',
        noOrders: 'Keine Bestellungen vorhanden.',
        orderNumber: 'Bestellnummer',
        orderDate: 'Bestelldatum',
        items: 'Artikel',
        total: 'Gesamtsumme',
        status: {
            pending: 'Ausstehend',
            paid: 'Bezahlt',
            completed: 'Abgeschlossen',
            cancelled: 'Storniert',
            refunded: 'Erstattet',
        },
        paymentStatus: {
            pending: 'Ausstehend',
            processing: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            failed: 'Fehlgeschlagen',
        },
        actions: {
            view: 'Details anzeigen',
            cancel: 'Stornieren',
            download: 'Rechnung herunterladen',
        },
        detail: {
            title: 'Bestelldetails',
            customerInfo: 'Kundendaten',
            billingAddress: 'Rechnungsadresse',
            orderItems: 'Bestellte Artikel',
            paymentInfo: 'Zahlungsinformationen',
        },
        messages: {
            cancelSuccess: 'Bestellung erfolgreich storniert',
            cancelError: 'Fehler beim Stornieren der Bestellung',
        },
    },
    checkout: {
        title: 'Kasse',
        steps: {
            review: 'Überprüfen',
            customer: 'Kundendaten',
            payment: 'Zahlung',
            confirmation: 'Bestätigung',
        },
        customerForm: {
            title: 'Ihre Daten',
            email: 'E-Mail-Adresse',
            name: 'Vollständiger Name',
            billingAddress: 'Rechnungsadresse',
            street: 'Straße und Hausnummer',
            city: 'Stadt',
            postalCode: 'Postleitzahl',
            country: 'Land',
        },
        summary: {
            title: 'Bestellübersicht',
            subtotal: 'Zwischensumme',
            discount: 'Rabatt',
            tax: 'MwSt.',
            total: 'Gesamtsumme',
        },
        payment: {
            title: 'Zahlungsmethode',
            paypal: 'Mit PayPal bezahlen',
            processing: 'Zahlung wird verarbeitet...',
        },
        confirmation: {
            title: 'Bestellung bestätigt!',
            thankYou: 'Vielen Dank für Ihre Bestellung!',
            orderNumber: 'Ihre Bestellnummer: %{orderNumber}',
            emailSent: 'Eine Bestätigungsmail wurde an %{email} gesendet.',
            viewOrders: 'Meine Bestellungen',
            continueShopping: 'Weiter einkaufen',
        },
        errors: {
            validationFailed: 'Bitte füllen Sie alle erforderlichen Felder aus.',
            paymentFailed: 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
            orderCreationFailed: 'Fehler beim Erstellen der Bestellung.',
        },
    },
    // ------------------------------------------------------------------
    // Marktplatz-Rework (docs/dev/marketplace-rework-plan.md, Abschnitt 4):
    // leere Namespaces, in T1 angelegt — jede Tranche hängt ihre Keys nur an.
    // ------------------------------------------------------------------
    /** T5 — Verkäufer-Dashboard, Angebote, Abrechnungen */
    marketplaceSeller: {
        title: 'Verkäufer-Dashboard',
        subtitle: 'Eigene Kurse auf dem Marktplatz anbieten, Verkäufe verfolgen und Abrechnungen einsehen.',
        openMarketplace: 'Zum Marktplatz',
        openDashboard: 'Zum Verkäufer-Dashboard',
        dashboardHint: 'Neue Angebote, Einreichung und Verkaufsübersicht finden Sie im Verkäufer-Dashboard.',
        nav: {
            overview: 'Übersicht',
            listings: 'Meine Angebote',
            statements: 'Abrechnungen',
            billing: 'Rechnungsdaten und PayPal',
        },
        visibility: {
            title: 'Wo anbieten?',
            public: {
                label: 'Öffentlich',
                short: 'Öffentlich',
                hint: 'Öffentlich: Alle Kunden der online:academy sehen das Angebot. Die Zahlung läuft über PayPal, die Plattformgebühr beträgt %{fee} %. Neue öffentliche Angebote werden vor der Veröffentlichung geprüft.',
            },
            group: {
                label: 'Nur meine Unternehmensgruppe',
                short: 'Unternehmensgruppe',
                hint: 'Nur meine Unternehmensgruppe: Das Angebot sehen ausschließlich Ihre %{count} Unternehmen der Gruppe: %{names}. Keine Gebühr, keine PayPal-Zahlung, keine Prüfung, das Angebot ist sofort verfügbar.',
                more: 'und %{count} weitere',
            },
        },
        groupPricing: {
            title: 'Für meine Unternehmensgruppe',
            introPublic: 'Welchen Preis zahlen Unternehmen Ihrer Gruppe? Fremde Unternehmen zahlen immer den Listenpreis.',
            introGroup: 'Welchen Preis zahlen die Unternehmen Ihrer Gruppe?',
            same: 'Gleicher Preis wie für alle (Zahlung über PayPal)',
            free: 'Kostenlos',
            internal: 'Interner Verrechnungspreis (Belastungsanzeige, keine PayPal-Zahlung)',
            priceGroup: 'Interner Verrechnungspreis (netto)',
            priceGroupHelp: 'Wird dem Unternehmen als Belastungsanzeige gestellt, kein steuerlicher Beleg.',
        },
        status: {
            draft: 'Entwurf',
            in_review: 'In Prüfung',
            published: 'Veröffentlicht',
            rejected: 'Abgelehnt',
            withdrawn: 'Zurückgezogen',
        },
        editor: {
            titleNew: 'Kurs im Marktplatz anbieten',
            titleEdit: 'Angebot bearbeiten',
            steps: { course: 'Kurs und Texte', pricing: 'Lizenzmodelle und Preise', visibility: 'Wo anbieten' },
            stepOf: 'Schritt %{current} von %{total}',
            lockedHint: 'Das Angebot ist veröffentlicht: Beschreibung und Schlagwörter lassen sich ändern. Für Preise, Lizenzmodelle und Sichtbarkeit zuerst zurückziehen und danach erneut einreichen.',
            rejectedHint: 'Das Angebot wurde abgelehnt: %{reason}',
            course: 'Kurs',
            courses: 'Kurse im Angebot',
            coursesHelp: 'Mehrere Kurse bilden ein Bundle: ein Angebot, ein Preis, je Kurs eine Lizenz. Der erste Kurs ist der Primärkurs.',
            selectedCourses: 'Gewählte Kurse',
            primary: 'Primärkurs',
            searchCourses: 'Kurse suchen …',
            noCourseFound: 'Keine Kurse gefunden.',
            alreadyOffered: 'bereits angeboten',
            moveEarlier: '%{title} nach vorn',
            removeCourse: '%{title} entfernen',
            removeTag: 'Schlagwort %{tag} entfernen',
            title: 'Angebotstitel',
            titleHelp: 'Leer lassen, um den Kurstitel zu verwenden.',
            titleHelpBundle: 'Pflicht bei mehreren Kursen: Name des Bundles, z. B. „Soft-Skills-Paket“.',
            description: 'Beschreibung',
            tags: 'Schlagwörter',
            tagsHelp: 'Enter oder Komma fügt ein Schlagwort hinzu; Rücktaste entfernt das letzte.',
            category: 'Kategorie',
            noCategory: 'Keine Kategorie',
            pricesNetHint: 'Alle Preise sind Nettopreise, zuzüglich gesetzlicher Umsatzsteuer.',
            feeHint: 'Bei öffentlichen Angeboten wird die Plattformgebühr von %{fee} % vor der Auszahlung abgezogen.',
            models: {
                reference: 'Referenz-Lizenz',
                referenceHelp: 'Live-Verknüpfung: Der Käufer nutzt Ihren Kurs, Änderungen wirken sofort.',
                copy: 'Kopie-Lizenz',
                copyHelp: 'Der Käufer erhält eine eigene Kopie, die er anpassen kann.',
                seat: 'Teilnehmer-Lizenz',
                seatHelp: 'Kopie mit fester Teilnehmerzahl, der Preis gilt pro Platz.',
            },
            priceNet: 'Preis (netto)',
            priceSeat: 'Preis pro Platz (netto)',
            yourShare: 'Ihr Anteil nach Plattformgebühr: %{amount}',
            next: 'Weiter',
            save: 'Speichern',
            saveDraft: 'Als Entwurf speichern',
            saveAndSubmit: 'Speichern und einreichen',
            saved: 'Angebot gespeichert.',
            submitted: 'Angebot eingereicht.',
            errors: {
                course: 'Bitte wählen Sie mindestens einen Kurs aus.',
                bundleTitle: 'Bei mehreren Kursen ist ein Angebotstitel erforderlich.',
                noModel: 'Bitte bieten Sie mindestens ein Lizenzmodell an.',
                price: 'Bitte geben Sie für jedes angebotene Lizenzmodell einen Preis von 0 oder mehr an.',
                priceGroup: 'Bitte geben Sie einen internen Verrechnungspreis größer 0 an.',
                save: 'Das Angebot konnte nicht gespeichert werden.',
            },
        },
        listings: {
            title: 'Meine Angebote',
            intro: 'Öffentliche Angebote werden vor Veröffentlichung geprüft. Gruppenangebote sind sofort sichtbar.',
            new: 'Kurs anbieten',
            empty: 'Sie haben noch keine Angebote. Mit „Kurs anbieten“ legen Sie das erste an.',
            loadError: 'Die Angebote konnten nicht geladen werden.',
            actionError: 'Die Aktion konnte nicht ausgeführt werden.',
            edit: 'Bearbeiten',
            submit: 'Einreichen',
            withdraw: 'Zurückziehen',
            delete: 'Löschen',
            submitted: 'Angebot zur Prüfung eingereicht.',
            published: 'Angebot veröffentlicht.',
            withdrawn: 'Angebot zurückgezogen.',
            deleted: 'Angebot gelöscht.',
            col: { course: 'Kurs', visibility: 'Sichtbarkeit', status: 'Status', prices: 'Preise (netto)', sales: 'Verkäufe', actions: 'Aktionen' },
            priceRef: 'Referenz',
            priceCopy: 'Kopie',
            priceSeat: 'Platz',
            rejectedReason: 'Abgelehnt: %{reason}',
            inReviewHint: 'Wird geprüft. Bearbeiten ist erst nach dem Zurückziehen möglich.',
            warnings: {
                billing_incomplete: 'Rechnungsdaten unvollständig.',
                paypal_not_connected: 'PayPal-Konto noch nicht verbunden.',
            },
            confirmWithdrawTitle: 'Angebot zurückziehen?',
            confirmWithdraw: '„%{title}“ ist danach nicht mehr im Marktplatz sichtbar. Bestehende Lizenzen bleiben gültig.',
            confirmDeleteTitle: 'Angebot löschen?',
            confirmDelete: '„%{title}“ wird endgültig gelöscht.',
        },
        overview: {
            loadError: 'Die Verkaufsübersicht konnte nicht geladen werden.',
            readinessTitle: 'Für bezahlte öffentliche Angebote fehlen noch Angaben.',
            readinessAction: 'Jetzt ergänzen',
            missing: {
                billing_data: 'Die Rechnungsstammdaten sind unvollständig.',
                bank_account: 'Es ist keine Bankverbindung hinterlegt.',
                paypal: 'Das PayPal-Konto ist noch nicht verbunden.',
            },
            period: { label: 'Zeitraum', '30d': '30 Tage', '90d': '90 Tage', '365d': '12 Monate', all: 'Gesamt' },
            groupFree: 'kostenlos (Gruppe)',
            internalCharges: 'Interne Verrechnung an Ihre Unternehmensgruppe: %{amount} in %{count} Lizenzen. Das zählt nicht zum Umsatz.',
            chartTitle: 'Umsatz pro Monat',
            series: { gross: 'Brutto-Umsatz', net: 'Ihr Anteil' },
            recentSales: 'Letzte Verkäufe',
            allStatements: 'Alle Abrechnungen',
            noSales: 'Noch keine Verkäufe im Zeitraum.',
            reviews: {
                title: 'Bewertungen',
                summary: '%{count} Bewertungen, Durchschnitt %{average}',
                empty: 'Noch keine Bewertungen für Ihre Angebote.',
                reply: 'Ihre Antwort',
            },
        },
        kpi: {
            gross: 'Brutto-Umsatz',
            grossHint: 'Öffentliche Verkäufe, netto ohne USt',
            sales: 'Verkäufe',
            salesGroup: 'davon %{count} kostenlos in der Gruppe',
            currentNet: 'Laufender Monat',
            currentNetHint: 'Ihr Anteil nach Plattformgebühr',
            paidOut: 'Abgerechnet (Jahr)',
            paidOutHint: 'Als bezahlt markierte Abrechnungen',
        },
        sales: {
            date: 'Datum',
            course: 'Kurs',
            buyer: 'Käufer',
            origin: 'Herkunft',
            license: 'Lizenz',
            net: 'Preis (netto)',
            fee: 'Gebühr',
            share: 'Ihr Anteil',
            types: { reference: 'Referenz', copy: 'Kopie', seat_copy: 'Teilnehmer' },
        },
        statements: {
            title: 'Abrechnungen',
            intro: 'Monatliche Übersicht über Umsatz, Plattformgebühr und Ihren Anteil. Die Übersicht ist kein steuerlicher Beleg.',
            empty: 'Es liegen noch keine Abrechnungen vor.',
            loadError: 'Die Abrechnungen konnten nicht geladen werden.',
            period: 'Zeitraum',
            number: 'Nummer',
            gross: 'Umsatz',
            fee: 'Gebühr',
            net: 'Ihr Anteil',
            status: 'Status',
            statuses: { open: 'Offen', paid: 'Bezahlt', void: 'Storniert' },
        },
        billing: {
            loadError: 'Die Rechnungsdaten konnten nicht geladen werden.',
            synced: 'Rechnungsdaten abgeglichen.',
            paypal: {
                title: 'PayPal-Konto',
                status: {
                    not_started: 'Nicht verbunden',
                    pending: 'Verbindung in Prüfung',
                    completed: 'Verbunden',
                    revoked: 'Verbindung widerrufen',
                },
                explain: 'Für bezahlte öffentliche Angebote verbinden Sie Ihr PayPal-Geschäftskonto. Kunden zahlen direkt an Sie, die Plattformgebühr wird automatisch einbehalten.',
                connectedText: 'Ihr PayPal-Konto ist verbunden, Zahlungen können empfangen werden.',
                connect: 'Mit PayPal verbinden',
                notAvailable: 'Die Verbindung mit PayPal ist noch nicht freigeschaltet.',
                error: 'Die Verbindung mit PayPal konnte nicht gestartet werden.',
                groupHint: 'Angebote nur für Ihre Unternehmensgruppe brauchen kein PayPal-Konto.',
            },
            profile: {
                title: 'Rechnungsstammdaten',
                sync: 'Abgleichen',
                incomplete: 'Die Angaben sind unvollständig. Rechnungen an Ihre Kunden brauchen Anschrift und Steuernummer oder USt-IdNr.',
                legalName: 'Firmenname',
                missing: 'fehlt',
                address: 'Anschrift',
                taxNumber: 'Steuernummer',
                vatId: 'USt-IdNr.',
                smallBusiness: 'Kleinunternehmer (§ 19 UStG)',
                email: 'Rechnungs-E-Mail',
                iban: 'IBAN',
                accountHolder: 'Kontoinhaber',
                none: 'Es liegen noch keine Rechnungsstammdaten vor.',
                editHint: 'Die Angaben stammen aus den Unternehmensdaten. Änderungen dort vornehmen und danach „Abgleichen“ wählen.',
            },
        },
    },
    /** T6 — Katalog, Detailseite, Checkout, Lizenzen */
    marketplaceBuyer: {
        bundle: {
            pill: 'Bundle · %{count} Kurse',
            licensePill: 'Aus Bundle: %{title}',
            factCourses: '%{count} Kurse im Paket',
            more: '+ %{count} weitere',
            includes: 'Enthaltene Kurse (%{count})',
            checkoutHint: 'Der Preis gilt für das gesamte Paket. Sie erhalten für jeden Kurs eine eigene Lizenz.',
            priceNote: 'Der Preis gilt für alle %{count} Kurse zusammen.',
            alreadyLicensed: 'Sie besitzen bereits einen Kurs aus diesem Bundle. Ein bereits lizenzierter Kurs kann nicht erneut erworben werden — das Bundle ist deshalb nicht kaufbar.',
            licenseCount: '%{count} Lizenzen',
        },
        title: 'Marktplatz',
        subtitle: 'Kurse anderer online:academy-Kunden lizenzieren und direkt im eigenen Portal einsetzen.',
        netPayPalNote: 'Preise netto zzgl. USt · Zahlung über PayPal',
        filter: {
            level: 'Niveau',
            allLevels: 'Alle Niveaus',
            sort: 'Sortierung',
            sortNew: 'Neueste zuerst',
            sortName: 'Name A–Z',
            sortPrice: 'Preis aufsteigend',
        },
        loadError: 'Der Marktplatz konnte nicht geladen werden.',
        readOnlyHint: 'Lizenzieren, Lizenzen und Rechnungen sind Company-Admins vorbehalten. Sie sehen das Angebot und die Preise.',
        search: 'Angebote durchsuchen',
        nav: {
            browse: 'Angebote',
            licenses: 'Meine Lizenzen',
            orders: 'Bestellungen und Rechnungen',
        },
        tabs: {
            ariaLabel: 'Bereich des Marktplatzes',
            public: 'Öffentlicher Marktplatz',
            group: 'Angebote meiner Unternehmensgruppe',
        },
        scopeHint: {
            public: 'Angebote aller Kunden der online:academy. Die Zahlung läuft über PayPal, Preise verstehen sich netto zuzüglich USt.',
            group: 'Angebote von Unternehmen Ihrer Unternehmensgruppe. Kostenlos oder mit internem Verrechnungspreis, ohne PayPal-Zahlung.',
        },
        empty: {
            public: 'Im öffentlichen Marktplatz gibt es aktuell keine passenden Angebote.',
            group: 'Ihre Unternehmensgruppe bietet aktuell keine passenden Angebote an.',
        },
        difficulty: {
            beginner: 'Einstieg',
            intermediate: 'Vertiefung',
            advanced: 'Spezialisierung',
        },
        card: {
            licensed: 'Lizenziert',
            lessons: '%{count} Lektionen',
            details: 'Details',
            license: 'Lizenzieren',
        },
        price: {
            free: 'Kostenlos',
            groupFree: 'Gruppenpreis: kostenlos',
            groupInternal: 'Gruppenpreis: intern',
            perSeat: 'pro Platz',
            net: 'netto',
            reference: 'Referenz',
            copy: 'Kopie',
            seat: 'Teilnehmer',
        },
        licenseType: {
            reference: {
                label: 'Referenz-Lizenz',
                chip: 'Referenz',
                hint: 'Live-Verknüpfung zum Kurs des Anbieters, Änderungen erscheinen automatisch.',
            },
            copy: {
                label: 'Kopie-Lizenz',
                chip: 'Kopie',
                hint: 'Unabhängige Kopie in Ihrem Katalog, Sie können den Kurs anpassen.',
            },
            seat_copy: {
                label: 'Teilnehmer-Lizenz',
                chip: 'Teilnehmer',
                hint: 'Kopie mit fester Teilnehmerzahl, Preis pro Platz.',
            },
        },
        detail: {
            notFound: 'Dieses Angebot gibt es nicht oder es ist für Sie nicht sichtbar.',
            back: 'Zurück zum Marktplatz',
            highlights: 'Highlights',
            previewVideo: 'Vorschauvideo ansehen',
            lessons: 'Inhalt: %{count} Lektionen',
            prices: 'Preise',
            netNote: 'Alle Preise netto, zuzüglich gesetzlicher USt.',
            own: 'Das ist Ihr eigenes Angebot. Verwalten können Sie es im Verkäufer-Dashboard.',
            content: 'Inhalt',
            tags: 'Schlagwörter',
            collapseAll: 'Alle ausblenden',
            expandAll: 'Alle einblenden',
            toggleSection: 'Abschnitt ein- oder ausblenden: %{title}',
            toggleCourse: 'Kurs ein- oder ausblenden: %{title}',
            kind: {
                lesson: 'Lektion',
                test: 'Test',
            },
            minutes: '%{count} Min.',
            hours: 'ca. %{value} Std.',
            factLessons: '%{count} Lektionen',
            factDuration: 'Lernzeit',
            chooseLicense: 'Lizenz wählen',
            sum: 'Gesamt netto',
            vatNote: 'netto zzgl. USt · Zahlung über PayPal',
            trustInstant: 'Sofort nach Zahlung verfügbar',
            trustInvoice: 'Rechnung vom Anbieter als PDF',
            sellerFallback: 'Anbieter',
            sellerInfo: 'Anbieter · %{smart_count} Angebot auf dem Marktplatz |||| Anbieter · %{smart_count} Angebote auf dem Marktplatz',
            sellerInvoice: 'Rechnung direkt vom Anbieter',
            allOffers: 'Alle Angebote',
            licenseOptions: 'Lizenzart',
        },
        checkout: {
            title: 'Kurs lizenzieren',
            success: 'Lizenz erfolgreich erworben!',
            error: 'Die Bestellung konnte nicht angelegt werden.',
            captureError: 'Die Zahlung konnte nicht abgeschlossen werden.',
            processing: 'Wird verarbeitet...',
            toPayment: 'Weiter zur Zahlung',
            getInternal: 'Zum Gruppenpreis beziehen',
            getFree: 'Kostenlos beziehen',
            origin: {
                public: 'Öffentliches Angebot des Marktplatzes: Anbieter ist ein anderes Unternehmen, die Zahlung läuft über PayPal.',
                group: 'Angebot Ihrer Unternehmensgruppe: Für Sie gilt der Gruppenpreis, es folgt keine PayPal-Zahlung.',
            },
            licenseType: 'Lizenzart',
            seats: 'Anzahl Teilnehmer-Plätze',
            seatsHint: 'Jeder Teilnehmer, der eingeschrieben wird und beginnt, belegt dauerhaft einen Platz. Plätze gestarteter Teilnehmer werden bei Ausschreibung nicht wieder frei.',
            seatsTimes: '%{seats} Plätze × %{price} pro Platz',
            targetCatalog: 'Zielkatalog',
            targetCatalogHelp: 'In diesem Katalog Ihrer Kursverwaltung wird die Kopie abgelegt.',
            defaultCatalog: 'Lizenzierte Kurse (Standard)',
            settlement: {
                paypal: 'Zahlung über PayPal. Der Preis ist netto, die USt kommt hinzu. Den Endbetrag sehen Sie im nächsten Schritt.',
                free: 'Kostenlos: Die Lizenz ist sofort aktiv, es folgt weder eine Zahlung noch eine Rechnung.',
                internal: 'Interner Verrechnungspreis: Ihr Unternehmen erhält eine Belastungsanzeige. Es folgt keine PayPal-Zahlung, die Anzeige ist kein steuerlicher Beleg.',
            },
            paypalUnavailable: 'PayPal ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.',
            sellerNoPaypal: 'Der Anbieter hat PayPal noch nicht verbunden, der Kauf ist derzeit nicht möglich.',
            alreadyLicensed: 'Sie haben diesen Kurs bereits lizenziert.',
            orderCreated: 'Bestellung %{number} angelegt. Gesamtbetrag %{total}. Bezahlen Sie jetzt über PayPal.',
            taxBreakdown: 'Netto %{net} zuzüglich USt (%{rate} %) %{tax}.',
            cancelled: 'Die Zahlung wurde abgebrochen. Sie können es erneut versuchen.',
            paypalError: 'Bei PayPal ist ein Fehler aufgetreten. Es wurde nichts abgebucht.',
            doneBody: {
                paypal: 'Vielen Dank, die Zahlung ist eingegangen. Ihre Lizenz ist aktiv, die Rechnung finden Sie unter Bestellungen und Rechnungen.',
                free: 'Die Lizenz ist aktiv.',
                internal: 'Die Lizenz ist aktiv. Ihr Unternehmen erhält dazu eine Belastungsanzeige.',
            },
            close: 'Schließen',
            toLicenses: 'Zu meinen Lizenzen',
            cancel: 'Abbrechen',
        },
        licenses: {
            title: 'Erworbene Lizenzen',
            intro: 'Ihre erworbenen Lizenzen mit Platzbelegung und Status der Medienkopie. Einschreibungen und Einstellungen verwalten Sie unter Lizenzierte Kurse.',
            manage: 'Lizenzierte Kurse',
            empty: 'Sie haben noch keine Kurse lizenziert.',
            loadError: 'Die Lizenzen konnten nicht geladen werden.',
            seats: 'Teilnehmer-Plätze',
            seatsOf: '%{used} von %{max} belegt',
            seatsUnlimited: '%{used} belegt, unbegrenzt',
            seatsFull: 'Alle Plätze sind belegt.',
            copyOf: 'Kopie: %{title}',
            since: 'Erworben am %{date}',
            expires: 'läuft ab am %{date}',
            revoked: 'Widerrufen: %{reason}',
            status: {
                pending: 'Ausstehend',
                active: 'Aktiv',
                suspended: 'Pausiert',
                expired: 'Abgelaufen',
                revoked: 'Widerrufen',
            },
            media: {
                pending: { title: 'Medien warten auf Kopie', hint: 'Videos, H5P-Inhalte und Dateien werden gleich in Ihren Mandanten kopiert.' },
                running: { title: 'Medien werden kopiert', hint: 'Der Kurs ist bereits nutzbar, Medien erscheinen nach und nach.' },
                done: { title: 'Medien vollständig kopiert', hint: 'Alle Inhalte liegen in Ihrem Mandanten.' },
                failed: { title: 'Medienkopie fehlgeschlagen', hint: 'Der Kurs bleibt nutzbar. Mit Erneut versuchen werden fehlende Medien nachgeholt.' },
                retry: 'Erneut versuchen',
                retryStarted: 'Die Medienkopie wurde neu gestartet.',
                retryError: 'Die Medienkopie konnte nicht neu gestartet werden.',
            },
        },
        orders: {
            title: 'Bestellungen',
            intro: 'Alle Lizenzbestellungen inklusive kostenloser Gruppenangebote.',
            invoicesIntro: 'Belege der Verkäufer, als PDF herunterladen.',
            empty: 'Sie haben noch keine Bestellungen im Marktplatz.',
            loadError: 'Die Bestellungen konnten nicht geladen werden.',
            downloadError: 'Die Rechnung konnte nicht geladen werden.',
            date: 'Datum',
            number: 'Bestellnummer',
            item: 'Kurs und Lizenzart',
            amount: 'Betrag',
            settlement: 'Abwicklung',
            status: 'Status',
            settlements: {
                paypal: 'PayPal',
                free: 'Kostenlos',
                internal: 'Belastungsanzeige',
            },
            statuses: {
                pending: 'Offen',
                paid: 'Bezahlt',
                completed: 'Abgeschlossen',
                cancelled: 'Storniert',
                payment_failed: 'Zahlung fehlgeschlagen',
                refunded: 'Erstattet',
                partially_refunded: 'Teilweise erstattet',
            },
            invoicesTitle: 'Rechnungen',
            invoicesUnavailable: 'Rechnungen sind hier nach dem Kauf abrufbar. Aktuell lassen sie sich nicht laden.',
            invoicesEmpty: 'Es liegen noch keine Rechnungen vor. Kostenlose Bezüge erzeugen keinen Beleg.',
            invoiceNumber: 'Rechnungsnummer',
            invoiceType: 'Beleg',
            issuer: 'Aussteller',
            pdf: 'PDF',
            download: 'Rechnung %{number} als PDF herunterladen',
            documentTypes: {
                invoice: 'Rechnung',
                cancellation: 'Stornorechnung',
                credit_note: 'Gutschrift',
                group_transfer: 'Belastungsanzeige (kein steuerlicher Beleg)',
            },
        },
    },
    /** T7 — Storefront (öffentliche Verkaufsseite) */
    storefront: {
        menu: 'Storefront',
        public: {
            nav: { home: 'Start', catalog: 'Kursangebot', cart: 'Warenkorb' },
            hero: { cta: 'Kurse ansehen' },
            featured: 'Empfohlene Kurse',
            features: 'Ihre Vorteile',
            testimonials: 'Das sagen unsere Teilnehmenden',
            faq: 'Häufige Fragen',
            catalog: { title: 'Kursangebot', empty: 'Derzeit sind keine Kurse verfügbar.', viewAll: 'Alle Kurse' },
            product: {
                free: 'Kostenlos',
                vatIncluded: 'inkl. gesetzlicher USt.',
                lifetime: 'Unbefristeter Zugang',
                timeLimited: 'Zugang für %{days} Tage',
                addToCart: 'In den Warenkorb',
                inCart: 'Im Warenkorb',
                buyNow: 'Jetzt buchen',
                back: 'Zurück zum Kursangebot',
                notFound: 'Dieser Kurs ist nicht (mehr) verfügbar.',
            },
            cart: {
                title: 'Warenkorb',
                empty: 'Ihr Warenkorb ist leer.',
                remove: 'Entfernen',
                total: 'Gesamtsumme',
                toCheckout: 'Zur Kasse',
            },
            checkout: {
                title: 'Bestellung',
                account: 'Ihre Zugangsdaten',
                loggedIn: 'Sie sind angemeldet und kaufen für Ihr bestehendes Konto.',
                guestDisabled: 'Bei diesem Anbieter ist ein Kauf nur mit Anmeldung möglich.',
                login: 'Anmelden',
                email: 'E-Mail',
                firstName: 'Vorname',
                lastName: 'Nachname',
                password: 'Passwort',
                passwordHelp: 'Mindestens 12 Zeichen. Für Ihren Zugang wird ein Konto angelegt.',
                billing: 'Rechnungsadresse',
                street: 'Straße und Hausnummer',
                zip: 'PLZ',
                city: 'Ort',
                country: 'Land (Kürzel, z. B. DE)',
                vatId: 'USt-IdNr. (optional, nur für Unternehmen)',
                acceptTerms: 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen und habe die Datenschutzerklärung gelesen.',
                acceptImmediateAccess: 'Ich stimme ausdrücklich zu, dass der Zugang sofort bereitgestellt wird, und weiß, dass damit mein Widerrufsrecht erlischt.',
                submit: 'Zahlungspflichtig bestellen',
                submitFree: 'Kostenlos einschreiben',
                summary: 'Ihre Bestellung',
                payPalTitle: 'Jetzt mit PayPal bezahlen',
                payPalLoading: 'PayPal wird geladen …',
                payPalUnavailable: 'PayPal ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
                processing: 'Bestellung wird verarbeitet …',
                errorGeneric: 'Die Bestellung konnte nicht abgeschlossen werden. Es wurde kein Betrag abgebucht.',
                paymentFailed: 'Die Zahlung konnte nicht abgeschlossen werden.',
            },
            order: {
                title: 'Ihre Bestellung',
                thanks: 'Vielen Dank für Ihre Bestellung!',
                thanksBody: 'Ihr Zugang ist freigeschaltet. Sie können sich jetzt anmelden und mit dem Lernen beginnen.',
                pending: 'Ihre Zahlung wird noch von PayPal bestätigt. Sie erhalten Zugang, sobald sie eingegangen ist.',
                failed: 'Die Zahlung ist fehlgeschlagen. Es wurde kein Betrag abgebucht.',
                number: 'Bestellnummer',
                toLogin: 'Zum Lernbereich',
                notFound: 'Bestellung nicht gefunden.',
                emailPrompt: 'Bitte geben Sie zur Bestätigung die E-Mail-Adresse Ihrer Bestellung ein.',
                show: 'Anzeigen',
            },
            footer: { terms: 'AGB', privacy: 'Datenschutz', poweredBy: 'Bereitgestellt über online:academy' },
            notFound: 'Diese Seite existiert nicht.',
            loadError: 'Die Seite konnte nicht geladen werden.',
        },
        admin: {
            title: 'Storefront',
            intro: 'Ihre öffentliche Verkaufsseite: Kurse ohne Login anzeigen und verkaufen. Preise sind Bruttopreise für Privatpersonen.',
            tabs: { settings: 'Einstellungen', products: 'Produkte', embeds: 'Einbetten' },
            notEnabledFeature: 'Die Storefront ist für Ihr Unternehmen nicht freigeschaltet.',
            publicLink: 'Öffentlicher Link',
            openStore: 'Storefront öffnen',
            settings: {
                enabled: 'Storefront veröffentlichen',
                enabledHelp: 'Solange sie nicht veröffentlicht ist, ist die Seite öffentlich nicht erreichbar.',
                slug: 'Adresse (Slug)',
                slugHelp: 'Nur Kleinbuchstaben, Ziffern und Bindestriche, 3–60 Zeichen. Die Seite liegt unter /store/<Slug>.',
                displayName: 'Anzeigename',
                heroTitle: 'Überschrift',
                heroSubtitle: 'Unterzeile',
                heroDescription: 'Beschreibung',
                heroImageUrl: 'Titelbild (URL, https://)',
                allowGuestCheckout: 'Kauf ohne vorherige Anmeldung erlauben',
                allowFreeEnrollment: 'Kostenlose Einschreibung erlauben',
                termsUrl: 'AGB (URL)',
                privacyPolicyUrl: 'Datenschutzerklärung (URL)',
                seoTitle: 'Seitentitel (SEO)',
                seoDescription: 'Meta-Beschreibung (SEO)',
                customCss: 'Eigenes CSS (optional)',
                features: 'Vorteile',
                faq: 'Häufige Fragen',
                testimonials: 'Stimmen',
                add: 'Hinzufügen',
                remove: 'Entfernen',
                featureTitle: 'Titel',
                featureDescription: 'Beschreibung',
                question: 'Frage',
                answer: 'Antwort',
                quote: 'Zitat',
                author: 'Name',
                role: 'Funktion',
                save: 'Speichern',
                saved: 'Storefront gespeichert.',
                saveError: 'Speichern fehlgeschlagen.',
                loadError: 'Die Storefront-Einstellungen konnten nicht geladen werden.',
            },
            products: {
                help: 'Reihenfolge, Empfehlung und Sichtbarkeit der Kurse in der Storefront. Neue Produkte legen Sie unter „Produkte“ an.',
                empty: 'Noch keine Produkte vorhanden.',
                title: 'Produkt',
                price: 'Preis (brutto)',
                status: 'Sichtbarkeit',
                featured: 'Empfohlen',
                position: 'Position',
                up: 'Nach oben',
                down: 'Nach unten',
                statusPublished: 'Sichtbar',
                statusDraft: 'Ausgeblendet',
                statusArchived: 'Archiviert',
                manage: 'Produkte verwalten',
                updateError: 'Änderung konnte nicht gespeichert werden.',
            },
        },
    },
    /** T8 — Embed-Widget */
    embed: {
        title: 'Widgets zum Einbetten',
        intro: 'Binden Sie Kurse Ihrer Storefront in Ihre eigene Website ein. Jedes Widget hat ein eigenes Token und ist nur für die Websites freigegeben, die Sie hier eintragen. Ein Klick führt immer zu Ihrer Storefront – bezahlt wird dort, nicht im Widget.',
        empty: 'Noch keine Widgets angelegt.',
        needsStorefront: 'Richten Sie zuerst auf dem Reiter Einstellungen Ihre Storefront ein und aktivieren Sie sie.',
        loadError: 'Die Widgets konnten nicht geladen werden.',
        create: 'Widget anlegen',
        columns: { label: 'Bezeichnung', type: 'Typ', origins: 'Erlaubte Websites', status: 'Status', lastUsed: 'Zuletzt genutzt', actions: 'Aktionen' },
        never: 'noch nie',
        noOrigins: 'Keine Website freigegeben – das Widget ist gesperrt',
        status: { active: 'Aktiv', revoked: 'Widerrufen' },
        types: {
            catalog: { label: 'Katalog', description: 'Raster mit allen veröffentlichten Kursen' },
            course_card: { label: 'Einzelner Kurs', description: 'Eine Kurskarte mit Preis und Link' },
            landing: { label: 'Empfehlungs-Band', description: 'Überschrift mit empfohlenen Kursen' },
            buy_button: { label: 'Button mit Preis', description: 'Kompakter Button oder Badge für einen Kurs' },
        },
        themes: { auto: 'Automatisch (Hell/Dunkel)', light: 'Hell', dark: 'Dunkel' },
        actions: { snippet: 'Einbetten', edit: 'Bearbeiten', revoke: 'Widerrufen' },
        form: {
            createTitle: 'Widget anlegen',
            editTitle: 'Widget bearbeiten',
            label: 'Bezeichnung',
            type: 'Typ',
            typeFixed: 'Der Typ kann nach dem Anlegen nicht mehr geändert werden.',
            theme: 'Darstellung',
            product: 'Kurs',
            productRequired: 'Bitte einen Kurs wählen.',
            noProducts: 'Keine veröffentlichten Produkte vorhanden.',
            origins: 'Erlaubte Websites (eine je Zeile)',
            originsHelp: 'Nur Schema, Host und optional Port, z. B. https://www.beispiel.de – keine Pfade, keine Platzhalter. Ohne Eintrag ist das Widget gesperrt.',
            save: 'Speichern',
            cancel: 'Abbrechen',
        },
        snippet: {
            title: 'Widget einbetten',
            intro: 'Fügen Sie diesen Code auf Ihrer Website ein. Die Website muss unter Erlaubte Websites eingetragen sein.',
            mode: 'Einbettungsart',
            modeScript: 'Script (direkt in die Seite)',
            modeIframe: 'iframe (abgeschottet, Höhe automatisch)',
            code: 'Code zum Einfügen',
            copy: 'Kopieren',
            copied: 'Code kopiert.',
            copyFailed: 'Kopieren nicht möglich – bitte den Code manuell markieren.',
            preview: 'Vorschau',
            previewError: 'Die Vorschau konnte nicht geladen werden.',
            previewTitle: 'Vorschau des Widgets',
            close: 'Schließen',
            revealError: 'Das Token konnte nicht abgerufen werden.',
        },
        revoke: {
            title: 'Widget widerrufen?',
            text: 'Das Widget „%{label}“ zeigt auf Ihrer Website sofort nichts mehr an. Das lässt sich nicht rückgängig machen.',
            confirm: 'Widerrufen',
            done: 'Widget widerrufen.',
        },
        saved: 'Widget gespeichert.',
        error: 'Das hat nicht geklappt.',
    },
    /** T4 — Rechnungsstammdaten, Rechnungen, Provisionsabrechnung */
    billing: {},
    /** T9 — Operator: Moderation, Refunds, Webhook-Events, DATEV */
    /** Marktplatz — Operator-Sicht (T9): Moderation, Bestellungen/Refund, Abrechnung, Webhook-Events, DATEV, Bewertungen */
    marketplaceOperator: {
        title: 'Marktplatz-Betrieb',
        intro: 'Angebote freigeben, Bestellungen erstatten, Abrechnungen auslösen und Zahlungsereignisse prüfen.',
        nav: {
            moderation: 'Moderation',
            orders: 'Bestellungen',
            settlements: 'Abrechnung',
            events: 'Zahlungsereignisse',
            datev: 'DATEV-Export',
            reviews: 'Bewertungen',
        },
        common: {
            loadError: 'Die Daten konnten nicht geladen werden.',
            actionError: 'Die Aktion ist fehlgeschlagen.',
            cancel: 'Abbrechen',
            reload: 'Neu laden',
            all: 'Alle',
            seller: 'Anbieter',
            buyer: 'Käufer',
            companyFallback: 'Mandant %{id}',
        },
        moderation: {
            title: 'Angebote in Prüfung',
            intro: 'Öffentliche Angebote erscheinen im Marktplatz erst nach Ihrer Freigabe. Gruppen-Angebote werden nicht moderiert.',
            empty: 'Keine Angebote in dieser Ansicht.',
            pending: '%{count} Angebot(e) warten auf Prüfung',
            filter: { in_review: 'In Prüfung', rejected: 'Abgelehnt', published: 'Veröffentlicht', all: 'Alle' },
            submitted: 'Eingereicht am %{date}',
            free: 'Kostenlos',
            preview: 'Vorschau',
            approve: 'Freigeben',
            reject: 'Ablehnen',
            approved: 'Angebot freigegeben. Der Anbieter wurde benachrichtigt.',
            rejected: 'Angebot abgelehnt. Der Anbieter wurde benachrichtigt.',
            rejectTitle: 'Angebot ablehnen',
            rejectIntro: 'Die Begründung wird dem Anbieter in der Benachrichtigung und per E-Mail mitgeteilt.',
            rejectReason: 'Begründung',
            rejectRequired: 'Bitte geben Sie eine Begründung an.',
            rejectConfirm: 'Ablehnen',
            gateTitle: 'Freigabe noch nicht möglich',
            gateIntro: 'Bezahlte öffentliche Angebote brauchen vollständige Rechnungsstammdaten und ein verbundenes PayPal-Konto des Anbieters.',
            gate: {
                billing_incomplete: 'Rechnungsstammdaten des Anbieters sind unvollständig.',
                paypal_not_connected: 'Das PayPal-Konto des Anbieters ist nicht verbunden.',
            },
            blocked: 'Freigabe nicht möglich: Voraussetzungen des Anbieters fehlen.',
            previewTitle: 'Vorschau des Angebots',
            fields: {
                seller: 'Anbieter',
                category: 'Kategorie',
                courses: 'Kurse im Bundle (%{count})',
                course: 'Kurs',
                difficulty: 'Schwierigkeit',
                lessons: 'Lektionen (%{count})',
                highlights: 'Highlights',
                tags: 'Schlagwörter',
                video: 'Vorschauvideo',
                prices: 'Preise (netto)',
                fee: 'Plattformgebühr',
                reference: 'Referenz-Lizenz',
                copy: 'Kopie-Lizenz',
                seat: 'Teilnehmer-Lizenz je Platz',
                rejectionReason: 'Frühere Ablehnung',
            },
        },
        orders: {
            title: 'Bestellungen',
            intro: 'Alle Marktplatz- und Storefront-Bestellungen mit Zahlungsweg über PayPal.',
            search: 'Bestellnummer, E-Mail oder UUID',
            statusFilter: 'Status',
            channelFilter: 'Kanal',
            channel: { marketplace: 'Marktplatz', storefront: 'Storefront' },
            statuses: {
                pending: 'Offen',
                paid: 'Bezahlt',
                completed: 'Abgeschlossen',
                cancelled: 'Storniert',
                payment_failed: 'Zahlung fehlgeschlagen',
                refunded: 'Erstattet',
                partially_refunded: 'Teilweise erstattet',
            },
            empty: 'Keine Bestellungen gefunden.',
            columns: { number: 'Bestellung', date: 'Datum', channel: 'Kanal', parties: 'Anbieter / Käufer', total: 'Betrag', refunded: 'Erstattet', status: 'Status', actions: 'Aktion' },
            refund: 'Erstatten',
            refundTitle: 'Bestellung %{number} erstatten',
            refundIntro: 'Die Erstattung läuft über PayPal im Namen des Anbieters; die Plattformgebühr wird anteilig zurückgegeben. Bei voller Erstattung verliert der Käufer den Zugang.',
            refundFull: 'Restbetrag voll erstatten (%{amount})',
            refundPartial: 'Teilbetrag erstatten',
            refundAmount: 'Betrag (brutto)',
            refundAmountInvalid: 'Bitte einen Betrag zwischen 0,01 und %{max} angeben.',
            refundReason: 'Grund (optional, geht an PayPal)',
            refundConfirm: 'Jetzt erstatten',
            refunded: 'Erstattung wurde gebucht.',
            notRefundable: 'Nicht erstattbar',
        },
        settlements: {
            title: 'Abrechnung',
            intro: 'Der Monatslauf erstellt je Anbieter eine Abrechnung und, falls Provision geschuldet wird, die Provisionsrechnung. Er ist wiederholbar und legt nichts doppelt an.',
            month: 'Monat',
            run: 'Abrechnungslauf starten',
            runDone: 'Abrechnungslauf %{month} abgeschlossen: %{ok} Abrechnung(en), %{failed} mit Fehler.',
            runEmpty: 'Im Monat %{month} gab es keine abrechnungsrelevanten Verkäufe.',
            empty: 'Noch keine Abrechnungen.',
            columns: { number: 'Nummer', company: 'Anbieter', period: 'Zeitraum', gross: 'Brutto', refunds: 'Erstattungen', fee: 'Provision', net: 'Anteil Anbieter', mode: 'Art', status: 'Status', actions: 'Aktion' },
            mode: { payout: 'Auszahlung', commission: 'Provision offen' },
            statuses: { open: 'Offen', paid: 'Bezahlt', void: 'Storniert' },
            markPaid: 'Als bezahlt markieren',
            markPaidTitle: 'Provisionsrechnung %{number} als bezahlt markieren',
            markPaidIntro: 'Für Anbieter im Direct-Modus: bestätigen Sie hier den Zahlungseingang der Provision (z. B. SEPA-Überweisung).',
            reference: 'Zahlungsreferenz (optional)',
            markPaidConfirm: 'Als bezahlt markieren',
            markedPaid: 'Als bezahlt markiert.',
        },
        events: {
            title: 'Zahlungsereignisse',
            intro: 'Eingegangene PayPal-Webhooks. Fehlgeschlagene Ereignisse können erneut verarbeitet werden; die Verarbeitung ist idempotent.',
            empty: 'Keine Ereignisse.',
            filter: { all: 'Alle', failed: 'Fehlgeschlagen', processed: 'Verarbeitet', received: 'Empfangen', ignored: 'Ignoriert' },
            columns: { received: 'Empfangen', type: 'Ereignis', resource: 'Referenz', status: 'Status', error: 'Fehler', actions: 'Aktion' },
            replay: 'Erneut verarbeiten',
            replayed: 'Ereignis erneut verarbeitet (%{result}).',
        },
        datev: {
            title: 'DATEV-Export',
            intro: 'Buchungsstapel der Plattform (Provisionsrechnungen, Gebühren) im DATEV-Format für Ihren Steuerberater. Jeder Export wird protokolliert und lässt sich erneut herunterladen.',
            from: 'Von',
            to: 'Bis',
            create: 'Export erstellen',
            created: 'Export mit %{count} Buchung(en) erstellt.',
            rangeInvalid: 'Bitte einen gültigen Zeitraum angeben (Bis nicht vor Von).',
            history: 'Bisherige Exporte',
            empty: 'Noch keine Exporte.',
            columns: { created: 'Erstellt', period: 'Zeitraum', scope: 'Sicht', bookings: 'Buchungen', file: 'Datei', actions: 'Aktion' },
            scope: { platform: 'Plattform', seller: 'Anbieter' },
            download: 'Herunterladen',
        },
        reviews: {
            title: 'Bewertungen',
            intro: 'Bewertungen werden ohne Vorabprüfung veröffentlicht. Unangemessene Beiträge können Sie ausblenden; sie zählen dann nicht mehr in den Durchschnitt.',
            empty: 'Keine Bewertungen.',
            filter: { all: 'Alle', approved: 'Sichtbar', hidden: 'Ausgeblendet' },
            hide: 'Ausblenden',
            unhide: 'Wieder einblenden',
            hidden: 'Ausgeblendet',
            visible: 'Sichtbar',
            updated: 'Bewertung aktualisiert.',
            reply: 'Antwort des Anbieters',
        },
    },
    /** Marktplatz — Bewertungen (T9): Anzeige auf der Detailseite, Formular auf der Lizenz-Karte */
    marketplaceReviews: {
        title: 'Bewertungen',
        count: '%{count} Bewertung(en)',
        noReviews: 'Noch keine Bewertungen.',
        average: 'Durchschnitt %{value} von 5',
        stars: '%{count} von 5 Sternen',
        starInput: '%{count} Sterne',
        mine: 'Ihre Bewertung',
        loadError: 'Die Bewertungen konnten nicht geladen werden.',
        anonymous: 'Ein Unternehmen',
        sellerReply: 'Antwort des Anbieters',
        reply: 'Antworten',
        editReply: 'Antwort bearbeiten',
        replyLabel: 'Ihre Antwort',
        replySave: 'Antwort speichern',
        replyRemove: 'Antwort entfernen',
        replySaved: 'Antwort gespeichert.',
        replyError: 'Die Antwort konnte nicht gespeichert werden.',
        write: 'Bewerten',
        edit: 'Bewertung ändern',
        yourRating: 'Ihre Bewertung: %{count} von 5',
        dialogTitle: 'Kurs bewerten',
        dialogIntro: 'Ihre Bewertung ist für alle Unternehmen im Marktplatz sichtbar. Pro Lizenz ist eine Bewertung möglich; Sie können sie später ändern.',
        ratingLabel: 'Sterne',
        ratingRequired: 'Bitte vergeben Sie 1 bis 5 Sterne.',
        titleLabel: 'Überschrift (optional)',
        bodyLabel: 'Ihre Erfahrung (optional)',
        submit: 'Bewertung speichern',
        saved: 'Danke für Ihre Bewertung.',
        error: 'Die Bewertung konnte nicht gespeichert werden.',
        cancel: 'Abbrechen',
    },
    /** Plattform-Einstellungen (Operator): Aussteller, DATEV, Gebühren, Läufe, PayPal, Umgebung */
    platformSettings: {
        title: 'Plattform-Einstellungen',
        intro: 'Hier pflegen Sie die Angaben, die bisher je Umgebung per Konfigurationsdatei gesetzt werden mussten. Ein Wert aus dieser Seite hat Vorrang; bleibt ein Feld leer, gilt der Wert aus der Umgebung (grau im Feld angezeigt).',
        loading: 'Einstellungen werden geladen',
        loadError: 'Die Einstellungen konnten nicht geladen werden.',
        save: 'Speichern',
        saved: 'Einstellungen gespeichert.',
        saveError: 'Die Einstellungen konnten nicht gespeichert werden.',
        invalid: 'Bitte die markierten Felder prüfen.',
        emptyHint: 'Leere Felder verwenden den Wert aus der Umgebung.',
        sourceDb: 'In der App gesetzt',
        sourceEnv: 'Aus der Umgebung',
        tabs: {
            issuer: 'Aussteller',
            datev: 'DATEV',
            fees: 'Gebühren',
            jobs: 'Läufe',
            paypal: 'PayPal',
            environment: 'Umgebung',
        },
        issuer: {
            fields: {
                name: 'Firmenname',
                legal_representative: 'Inhaber / Vertretungsberechtigte',
                email: 'E-Mail für Rechnungen',
                street: 'Straße und Hausnummer',
                zip: 'PLZ',
                city: 'Ort',
                country: 'Land (Ländercode)',
                website: 'Webseite',
                vat_id: 'USt-IdNr.',
                tax_number: 'Steuernummer',
                iban: 'IBAN',
                bic: 'BIC',
                register_court: 'Registergericht',
                commercial_register: 'Handelsregisternummer',
                primary_color: 'Akzentfarbe (#rrggbb)',
                footer: 'Fußzeile der Rechnung',
            },
            logo: 'Logo',
            logoUpload: 'Logo hochladen',
            logoRemove: 'Logo entfernen',
            logoHint: 'PNG, JPEG, WebP oder SVG, höchstens 256 KB. Das Logo erscheint auf den Provisionsrechnungen (PR-…).',
            logoType: 'Nur PNG, JPEG, WebP oder SVG sind erlaubt.',
            logoSize: 'Das Logo ist größer als 256 KB.',
            requirement: 'Für Provisionsrechnungen sind Name, Anschrift sowie USt-IdNr. oder Steuernummer Pflicht. Ohne diese Angaben stellt die Monatsabrechnung keine Provisionsrechnung aus.',
        },
        datev: {
            consultant_number: 'Beraternummer',
            client_number: 'Mandantennummer',
            chart_of_accounts: 'Kontenrahmen',
            account_length: 'Sachkontenlänge',
            fiscal_year_start_month: 'Beginn des Wirtschaftsjahres (Monat)',
        },
        fees: {
            marketplace_fee_percent: 'Plattformgebühr Marktplatz (%)',
            storefront_fee_percent: 'Plattformgebühr Storefront (%)',
            currency: 'Währung',
        },
        jobs: {
            intro: 'Diese Läufe starten automatisch über den Scheduler der Plattform. Ein leeres Cron-Feld verwendet den Standardzeitplan; Uhrzeiten gelten in der Serverzeit.',
            enabled: 'Aktiv',
            disabled: 'Inaktiv',
            cron: 'Zeitplan (Cron)',
            cronDefault: 'Standard: %{cron}',
            lastRun: 'Letzte Ausführung',
            neverRun: 'Noch nicht gelaufen',
            status: {
                ok: 'Erfolgreich',
                failed: 'Fehlgeschlagen',
                running: 'Läuft',
            },
        },
        paypal: {
            webhook_id: 'Webhook-ID',
            env: { sandbox: 'Sandbox', live: 'Live' },
            credentialsOk: 'Zugangsdaten gesetzt',
            credentialsMissing: 'Zugangsdaten fehlen',
            credentialsHint: 'PayPal-Client-ID und Secret müssen in der Umgebung gesetzt sein, bevor ein Webhook angelegt werden kann.',
            url: 'Webhook-URL dieser Umgebung',
            check: 'Webhook prüfen',
            register: 'Webhook registrieren',
            created: 'Webhook bei PayPal angelegt und die ID gespeichert.',
            exists: 'Webhook war bereits registriert, die ID wurde gespeichert.',
            error: 'PayPal konnte nicht erreicht werden.',
            registeredOk: 'Registriert (ID %{id}) und mit der gespeicherten ID identisch.',
            registeredMismatch: 'Registriert (ID %{id}), aber die gespeicherte ID weicht ab. Bitte „Webhook registrieren“ ausführen.',
            notRegistered: 'Für diese URL ist bei PayPal noch kein Webhook registriert.',
            missingEvents: 'Fehlende Ereignisse: %{events}',
        },
        environment: {
            intro: 'Zugangsdaten und Schlüssel bleiben in der Umgebung und werden hier nie angezeigt, nur ob sie gesetzt sind.',
            secrets: 'Zugangsdaten und Schlüssel',
            values: 'Betriebsparameter',
            set: 'Gesetzt',
            missing: 'Fehlt',
        },
    },
};
